let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
var id = getUrlParameter('id'), f_name, C_number, C_email, user__gender, user_gender, userHairStage, caseId, pdPrice = 0, strikeFinalCartPrice = 0, hairStage, isCartVariationUser = false;
var cohort = getUrlParameter('cohort'), factors = [];
if (cohort) { try { localStorage.setItem('cohort', cohort); } catch (e) {} } // carry cohort to checkout funnel
if(id) {
  localStorage.setItem('user-gender', 'female');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id == undefined) {
  id = getCookie('syntheticId'); 
}
(function() {
  if(!id) {
    if(window.location.pathname == '/pages/result4'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
  }else
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var baseUrls = {
      DEV: 'https://api.dev.hav-g.in/',
      PROD: 'https://api.hav-g.in/'
    }
    var tokens = {
      DEV:{ 
        "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
      },
      PROD: { 
        "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
      }
    }
    var token = tokens.PROD;
    var baseUrl = baseUrls.PROD;
    var liveendpoint = 'https://api.hav-g.in/dgReport/female?id=';
    liveendpoint = `${baseUrl}dgReport/female?id=`
    getFemaleResult(liveendpoint, id, token);
})();

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

function getFemaleResult(liveendpoint, id, token) {
  document.body.style.overflow = 'hidden';

  fetch(`${liveendpoint}${id}&isWebsite=true`, {
    headers: token
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.message && response.message === "Report is only for female") {
      const queryParams = window.location.search;
      window.location.href = `/pages/result4${queryParams}`;
    } else {
      let formFillDateStr = response?.User_Analysis?.case_created_date;
      let formFillDate = new Date(formFillDateStr);
      if (isNaN(formFillDate.getTime())) {
        formFillDateStr = getCookie('current_D0_date');
        formFillDate = new Date(formFillDateStr);
      }
      userHairStage = response?.User_Analysis?.hair_fall_stage?.toLowerCase();
      const caseId = response?.User_Analysis?.case_id;
      // March page scaled to 100% of thinning: every thinning-group user (any caseId, D0 and D+,
      // 'no widening' counts as thinning) is sent to the v2 result page.
      // Gated to the standard female-result4 page only (won't fire on other result pages or on v2 itself).
      try {
        var __v2Path = window.location.pathname.replace(/\/+$/, '');
        var __v2Stage = (userHairStage || '').trim();
        if (/\/pages\/female-result4$/.test(__v2Path)
            && (__v2Stage === 'hair thinning' || __v2Stage === 'side thinning' || __v2Stage === 'no widening')) {
          window.location.href = '/pages/female-result-4-v2' + window.location.search;
          return;
        }
      } catch (e) { console.error('v2 redirect check failed', e); }
      initMoneybackBanner(response);
      // const CART_VARIATION_PREFIXES = ['0','1','2','3','4','5','6','7'];
      // isCartVariationUser = !!(caseId && CART_VARIATION_PREFIXES.includes(String(caseId).charAt(0).toLowerCase()));
      // if (isCartVariationUser) {
        document.body.classList.add('cart-drawer-hide');
      // }
      const valiedChatCase =  caseId && /^[0-7]/.test(caseId);
      const today = new Date();   
      today.setHours(0, 0, 0, 0);
      // const validCase = caseId && /^[a-d]/.test(caseId);
      // if (!isNaN(formFillDate.getTime())) {
      const validCase = caseId && /^[a-d]/.test(caseId);
      const suppressFloatie = evaluateDPlusValidate(response);
      if (!suppressFloatie && !isNaN(formFillDate.getTime())) {
        if (formFillDate < today) {
      //  if(valiedChatCase){
      //       // .whats-app-wrapper disabled — no longer shown
      //     } else {
            const normalUserWrapper = document.querySelector('.whats-app-wrapper-normal-user');
            if (!normalUserWrapper) return;
            normalUserWrapper.classList.remove('d-none');
          // }
          const chatIconClick = document.querySelectorAll('.chat-icon-click-event');
          chatIconClick.forEach((clicked)=>{
            clicked.addEventListener('click', ()=>{
              if(valiedChatCase){
                chatIconClicked("chat_icon_clicked_female_test", caseId);
              }
            })
          })
        }
      }
      if (isNaN(formFillDate.getTime())) {
        formFillDateStr = getCookie('current_D0_date');
        formFillDate = new Date(formFillDateStr);
      }
      const now = new Date();
      const diffInMs = now - formFillDate;
      const oneDay = 24 * 60 * 60 * 1000;
      const cliniclEntryV3 = document.querySelector('.clinical-entry-v3');
      const resultsUiUpdateEl = document.querySelector('.results-ui-update');
     if (formFillDateStr && !isNaN(formFillDate.getTime())) {
      if (diffInMs <= oneDay) {
        console.log("d0 user he is");
        if (cliniclEntryV3) cliniclEntryV3.classList.remove('d-none');
      } else {
        console.log("d+ user");
        if (resultsUiUpdateEl) resultsUiUpdateEl.classList.remove('d-none');
      }
    }
      const additionalyBookaCall = document.querySelector(".fab-action-item.book-call-btn");
      if(additionalyBookaCall) additionalyBookaCall.href = `https://form.traya.health/pages/reschedule-slot/${caseId}?femaleResultPage=true`;
      const hairStage = response?.User_Analysis?.hair_fall_stage?.toLowerCase();
      const customValidStage = hairStage === "medium widening" || hairStage === "advanced widening" || hairStage === "coin size patches" || hairStage === "alopecia areata";
      const onboardingVideoElement = document.querySelector(".mini-onboarding-video--container");
      if(onboardingVideoElement){
        onboardingVideoElement.classList.remove('d-none');
        document.querySelectorAll(".video-wrapper").forEach(wrapper=>{
          initVideoPlayer(wrapper);
        });
      }
      const hairHealthSummeryContainer = document.querySelector(".hair-snapshot-section");
      const normalUserSummeryDetails = document.querySelector(".normal-user-details");
      hairHealthSummeryContainer.classList.remove('d-none');
      normalUserSummeryDetails.classList.add('d-none');
      document.body.classList.add('hairHealthSummeryContainer');
      showContent(response);
      initAppDiscountFlow(response);
      initWhyTrayaSection(response);
      trackMetaEvent(response.User_Analysis, "Viewed Content");
      rootCause(response?.root_causes);
      fireResultPageLandedEvent(response);
    }
  })
  .catch((error) => {
    console.error('Network Error: ', error);
  })
  .finally(() => {
    document.body.style.overflow = 'unset';
    clearCart();
  });
}


// chat flotie
function evaluateDPlusValidate(response) {
  const ua = response?.User_Analysis || {};

  const age = parseInt(ua.age, 10);
  const ageHit = !isNaN(age) && age < 24;

  const stage = (ua.hair_fall_stage || '').toLowerCase().trim();
 const stageHit = stage === 'alopecia areata';

  let joinDate = new Date(ua.case_created_date);
  if (isNaN(joinDate.getTime())) joinDate = new Date(getCookie('current_D0_date'));
  let days = NaN, dPlusHit = false;
  if (!isNaN(joinDate.getTime())) {
    days = Math.floor((Date.now() - joinDate.getTime()) / 86400000);
    dPlusHit = days >= 180;
  }

  console.log('FLOATIE SUPPRESS CHECK →', {
    rawAge: ua.age, age, ageHit,
    stage, stageHit,
    case_created_date: ua.case_created_date, days, dPlusHit,
    suppressed: ageHit || stageHit || dPlusHit
  });

  return ageHit || stageHit || dPlusHit;
}

function toggleEarlyStageBanner(caseId) {
  const banner = document.querySelector('.early-stage-banner');
  if (!banner) return;

  const shouldShow = /^[0-7]/.test(String(caseId ?? ''));
  banner.hidden = !shouldShow;
}

function isRootCauseReplacementCase(caseId) {
  return /^[4-7]/i.test(String(caseId || '').trim());
}

function applyRootCauseReplacement(caseId) {
  if (!isRootCauseReplacementCase(caseId)) return;

  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) rootCauseSectionWrapper.innerHTML = '';

  document.querySelectorAll('[data-root-cause-section], .root-cause-specific-callout')
    .forEach((el) => el.classList.add('d-none'));

  const reportSection = document.querySelector('.female-test-report-section');
  if (reportSection) {
    reportSection.classList.add('female-test-report-section--root-replaced', 'd-none');
  }

  const replacement = document.getElementById('understandHairFallSection');
  if (replacement) replacement.classList.remove('d-none');

  fireEvent('rp_root_cause_replacement_shown', caseId, '', 'real_reason_component');
}

function initVideoPlayer(wrapper){
  const video = wrapper.querySelector("video");
  const source = wrapper.querySelector("source");
  const thumbnail = wrapper.querySelector(".video-thumbnail");
  const playBtn = wrapper.querySelector(".video-play-btn");
  const controls = wrapper.querySelector(".video-controls");
  const playToggle = wrapper.querySelector(".play-toggle");
  const muteToggle = wrapper.querySelector(".mute-toggle");
  const progressBar = wrapper.querySelector(".video-progress-bar");
  const progressContainer = wrapper.querySelector(".video-progress");
  let isDragging = false;
  let wasPlaying = false;
  let hideControlsTimer = null;

  let userPaused = false;        // true only when the user pauses on purpose
  let userMuteChoice = null;     // null = never interacted, true = muted, false = unmuted
  let videoStarted = false;      // true once the video has been started
  let gestureArmed = false;

  const ICON_MUTED =
    `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Frame_1_3ca2c8c9-08ab-4d12-b091-d05de7195269.webp?v=1772691138" width="20" height="19">`;
  const ICON_UNMUTED =
    `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Frame_a67f8797-6af8-4af0-9378-9106e26ae92e.webp?v=1772691138" width="20" height="19">`;

  function setMuted(muted){
    video.muted = muted;
    if (muted) video.setAttribute("muted", "");
    else video.removeAttribute("muted");
    muteToggle.innerHTML = muted ? ICON_MUTED : ICON_UNMUTED;
  }

  function desiredMuted(){ return userMuteChoice !== false; }

  function ensureSourceLoaded(){
    if(!source.src){
      source.src = source.dataset.src;
      video.load();
    }
  }

  function isInViewport(){
    const r = wrapper.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.9 && r.bottom > vh * 0.1;
  }

  // Persistent play: retry on media-ready events AND a short timer before giving up.
  function playWithRetry(isAuto, attemptsLeft){
    if(attemptsLeft === undefined) attemptsLeft = 4;
    const attempt = video.play();
    if(attempt && typeof attempt.catch === "function"){
      attempt.catch((err)=>{
        if(attemptsLeft > 0){
          const retry = ()=>{ cleanup(); playWithRetry(isAuto, attemptsLeft - 1); };
          const cleanup = ()=>{
            video.removeEventListener("canplay", retry);
            video.removeEventListener("loadeddata", retry);
            clearTimeout(timer);
          };
          const timer = setTimeout(retry, 350);
          video.addEventListener("canplay", retry, { once: true });
          video.addEventListener("loadeddata", retry, { once: true });
        } else {
          handlePlayFailure(isAuto, err);
        }
      });
    }
  }

  function handlePlayFailure(isAuto, err){
    console.warn("[mini video] play() rejected:", err);
    if(isAuto){
      // Show poster so a tap can start it, AND arm a page-gesture recovery
      videoStarted = false;
      video.style.display = "none";
      thumbnail.style.display = "block";
      playBtn.style.display = "block";
      controls.style.display = "none";
      armGestureFallback();
    }
  }

  // First scroll/tap anywhere on the page starts the muted autoplay video if it
  // hasn't started yet and is on screen — no tap on the video itself required.
  function armGestureFallback(){
    if(gestureArmed) return;
    gestureArmed = true;
    const onGesture = ()=>{
      if(shouldAutoPlay && !videoStarted && isInViewport()){
        startVideo(true);
      } else if(source.src && video.paused && !userPaused && isInViewport()){
        playWithRetry(true);
      }
      if(!video.paused){
        document.removeEventListener("touchstart", onGesture);
        document.removeEventListener("click", onGesture);
        document.removeEventListener("scroll", onGesture);
        gestureArmed = false;
      }
    };
    document.addEventListener("touchstart", onGesture, { passive: true });
    document.addEventListener("click", onGesture);
    document.addEventListener("scroll", onGesture, { passive: true });
  }

  function showControls(){
    controls.style.opacity = "1";
    clearTimeout(hideControlsTimer);
    hideControlsTimer = setTimeout(()=>{
      if(!video.paused && !isDragging){
        controls.style.opacity = "0";
      }
    },3000);
  }

  // 100% rollout: auto-play for hair thinning + side thinning only
  const AUTOPLAY_STAGES = ["hair thinning", "side thinning"];
  const shouldAutoPlay = AUTOPLAY_STAGES.includes((userHairStage || "").toLowerCase().trim());

  function startVideo(isAuto){
    videoStarted = true;

    setMuted(desiredMuted()); // autoplay is muted by default
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    ensureSourceLoaded();

    video.style.display = "block";
    thumbnail.style.display = "none";
    playBtn.style.display = "none";
    controls.style.display = "flex";

    if(!isAuto){
      userPaused = false;
    }

    playWithRetry(isAuto);

    playToggle.innerHTML =
      `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play.webp?v=1772691178" width="32" height="32">`;

    if(!isAuto){
      fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    }
    showControls();
  }

  function togglePlay(){
    if(video.paused){
      userPaused = false;
      video.play();
      playToggle.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play.webp?v=1772691178" width="32" height="32">`;
      fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    }else{
      userPaused = true;
      video.pause();
      playToggle.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play_1.webp?v=1772691178" width="32" height="32">`;
      fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    }
    showControls();
  }

  function seekVideo(clientX){
    if(!isFinite(video.duration)) return;
    const rect = progressContainer.getBoundingClientRect();
    const position = (clientX - rect.left) / rect.width;
    const clamped = Math.max(0, Math.min(1, position));
    video.currentTime = clamped * video.duration;
    progressBar.style.width = clamped * 100 + "%";
    showControls();
  }

  function updateProgress(){
    if(!video.paused && !isDragging && isFinite(video.duration)){
      const progress = (video.currentTime / video.duration) * 100;
      progressBar.style.width = progress + "%";
    }
    requestAnimationFrame(updateProgress);
  }

  /* Event Listeners */
  thumbnail.addEventListener("click", () => startVideo(false));
  playBtn.addEventListener("click", () => startVideo(false));

  video.addEventListener("click", togglePlay);
  playToggle.addEventListener("click", togglePlay);

  muteToggle.addEventListener("click", () => {
    const nextMuted = !video.muted;
    setMuted(nextMuted);
    userMuteChoice = nextMuted;
    if (!nextMuted) {
      fireMiniVideoEvent("mini_onboarding_unmute_clicked", caseId);
    }
    showControls();
  });

  video.addEventListener("mousemove", showControls);
  video.addEventListener("touchstart", showControls);

  video.addEventListener("ended", () => {
    video.currentTime = 0;
    video.play();
  });

  progressContainer.addEventListener("click",(e)=>{ seekVideo(e.clientX); });

  progressContainer.addEventListener("mousedown",(e)=>{
    isDragging = true;
    wasPlaying = !video.paused;
    video.pause();
    seekVideo(e.clientX);
    showControls();
  });

  document.addEventListener("mousemove",(e)=>{
    if(!isDragging) return;
    seekVideo(e.clientX);
  });

  document.addEventListener("mouseup",()=>{
    if(isDragging && wasPlaying){ video.play(); }
    isDragging = false;
    showControls();
  });

  progressContainer.addEventListener("touchstart",(e)=>{
    isDragging = true;
    wasPlaying = !video.paused;
    video.pause();
    seekVideo(e.touches[0].clientX);
    showControls();
  },{passive:true});

  progressContainer.addEventListener("touchmove",(e)=>{
    if(!isDragging) return;
    seekVideo(e.touches[0].clientX);
  },{passive:true});

  progressContainer.addEventListener("touchend",()=>{
    if(wasPlaying){ video.play(); }
    isDragging = false;
    showControls();
  });

  updateProgress();

  // Pre-warm + arm a gesture safety net for eligible videos
  if (shouldAutoPlay) {
    setMuted(true);
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.preload = "auto";
    ensureSourceLoaded();
    armGestureFallback();
  }

  // Observe the WRAPPER (always rendered), not the <video> (display toggles).
  const viewportObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (shouldAutoPlay && !videoStarted) {
          startVideo(true);                 // reliable autoplay on first entry
        } else if (source.src && video.paused && !userPaused) {
          playWithRetry(false);             // resume, audio preserved
        }
      } else {
        if (!video.paused) { video.pause(); }
      }
    });
  }, { threshold: 0.25 });
  viewportObserver.observe(wrapper);
}

function setupLanguageToggle() {
  const langBtn = document.querySelector('.language-icon-toggle');
  const arrowIcon = document.querySelector('.language-arrow-icon');
  const langDropdown = document.querySelector('.language-dropdown');
  const headerWrapper = document.querySelector(".icons-flex-container");
  const langText = document.querySelector('.language-icon');
  const headerLanguageIcon = document.getElementById("language-icon-toggle");
  const params = new URLSearchParams(window.location.search);
  const currentPage = params.get("page");
  if (headerLanguageIcon) {
    const urlParams = new URLSearchParams(window.location.search);
    const utmCampaign = urlParams.get("utm_campaign") || "";
    const page = urlParams.get("page") || "";

   const hasAllKeys =
    (utmCampaign.includes("TRFTOF") &&
      utmCampaign.includes("OnlyMHCustomers") &&
      utmCampaign.includes("CelebSayaliSanjeev")) ||
    page.includes("marathi");
    console.log(urlParams.toString(), "TEST hasAllKeys", page, hasAllKeys);
    if (hasAllKeys) {
      headerLanguageIcon.classList.remove("d-none");
    } else {
      headerLanguageIcon.classList.add("d-none");
    }
  }
  // Toggle dropdown
  langBtn?.addEventListener('click', () => {
    langDropdown?.classList.toggle('open');
    langBtn.classList.toggle('white-background');
    arrowIcon?.classList.toggle('rotate');
  });

  headerLanguageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    document.getElementById("language-dropdown-toggle")?.classList.toggle("hidden");
    headerWrapper?.classList.toggle("hidden-dropdown");
  });
  document.querySelectorAll('.language-option').forEach(option => {
    option.addEventListener('click', function () {
      const selectedLang = this.getAttribute('lang');
      localStorage.setItem('selected_lang', selectedLang);

      // UI update
      if (langText) langText.textContent = selectedLang;

      document.querySelectorAll('.language-option').forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
    });
  });

  setLanguageFromStorage();
}

function setLanguageFromStorage() {
  const isFemaleResult7 = window.location.pathname.includes('female-result7');
  const selectedLang = isFemaleResult7 ? 'Marathish' : 'English';
  localStorage.setItem('selected_lang', selectedLang);
  const langText = document.querySelector('.language-icon');
  if (langText) langText.textContent = selectedLang;
  document.querySelectorAll('.language-option').forEach(opt => {
    opt.classList.remove('active');
    if (opt.getAttribute('lang') === selectedLang) {
      opt.classList.add('active');
    }
  });
}

function headerLanguageSelectorFR5(hairStage) {
  const id = new URLSearchParams(window.location.search);
  if (!id) return;

  const queryString = `?${id}`;

  const englishUrl = (function () {
    const customValidStage = ["medium widening", "advanced widening", "coin size patches", "alopecia areata"];
    const validStage = ["hair thinning", "side thinning", "no widening"];

    if (customValidStage.includes(hairStage)) {
      return `/pages/female-result2${queryString}`;
    } else if (validStage.includes(hairStage)) {
      return `/pages/female-result5${queryString}`;
    }
    return `/pages/female-result5${queryString}`;
  })();

  const marathiUrl = `/pages/female-result7${queryString}`;

  const options = document.querySelectorAll(".language-option");

  options.forEach(link => {
    const lang = link.getAttribute("hreflang");

    if (lang === "english") link.href = englishUrl;
    if (lang === "marathish") link.href = marathiUrl;
  });

  // Active state
  options.forEach(link => link.classList.remove("active"));
  document.querySelector('[hreflang="english"]')?.classList.add("active");

  setupLanguageToggle();
}

function rootCause(response) {
  let primaryRootCause = response?.primaryRootCause ?? [];
  let defaultRootCause = response?.defaultRootCause ?? [];
  const EXPERIMENT_PREFIXES = ["4", "5", "6", "7"];
  const casePrefix = String(caseId).charAt(0).toLowerCase();
  const isExperimentUser = EXPERIMENT_PREFIXES.includes(casePrefix);
  if (isExperimentUser) {
    const isDandruff = (rc) =>
      String(rc?.title || rc?.key || "").toLowerCase().includes("dandruff");

    const dandruffInPrimary = primaryRootCause.find(isDandruff);
    const dandruffInDefault = defaultRootCause.find(isDandruff);
    const dandruffItem = dandruffInPrimary || dandruffInDefault;

    if (dandruffItem) {
      primaryRootCause = primaryRootCause.filter((rc) => !isDandruff(rc));
      defaultRootCause = defaultRootCause.filter((rc) => !isDandruff(rc));

      const combinedPrimary = [dandruffItem, ...primaryRootCause];
      primaryRootCause = [combinedPrimary[0]];
      defaultRootCause = [...combinedPrimary.slice(1), ...defaultRootCause];
    }
  }

  let primaryRootCauseHtml = "";
  let primaryRootCauseContentHtml = "";

  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="32px" height="32px" loading="eager"/>
        </div>
        <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;

    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }

  const defaultRootCauseHtml = defaultRootCause
    .map((item) => {
      return `<li class="rootCause-nav-item" role="presentation">
        <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
          <div class="rootCauseLinkImg">
            <img src="${item?.details?.icon}" width="32px" height="32px" loading="eager"/>
          </div>
          <p class="mt-2">${item?.title}</p>
        </a>
      </li>`;
    })
    .join("");

  const defaultRootCauseContentHtml = defaultRootCause
    .map((item) => {
      return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
        <p class="m-0">${item?.details?.description?.english}</p></div>`;
    })
    .join("");

  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;

  const rootCauseSectionWrapper = document.getElementById("rootCouseSectionWrapper");
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

// ── HAIR STAGE TAG MAP ─────────────────────────────────────────────────────
const HAIR_STAGE_TAG_MAP = {
  "hair thinning": {
    title: "Thinning & Less Volume",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/thinning_less_volume_b099f614-36ea-48f9-a746-8283dbb97a60.webp?v=1776067672"
  },
  "side thinning": {
    title: "Side Thinning & Less Volume",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/side_thinning_less_volume_1a43d2d9-b4eb-4525-afb7-818b4a2ad545.webp"
  },
  "medium widening": {
    title: "Visible Scalp & Wide Partition",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/partition_widening_7e95914a-201d-44d9-b566-4a5cc537645d.webp"
  },
  "advanced widening": {
    title: "Visible Scalp & Wide Partition",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/partition_widening_7e95914a-201d-44d9-b566-4a5cc537645d.webp"
  },
  "coin size patches": {
    title: "Visible Scalp Patches",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_patches_fc475437-504d-4287-bf83-868d07a25570.webp"
  },
  "alopecia areata": {
    title: "Visible Scalp Patches",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_patches_fc475437-504d-4287-bf83-868d07a25570.webp"
  },
  "no widening": {
    title: "Thinning & Less Volume",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Thinning_less_volume.webp?v=1774856266"
  }
};

function getHairConditionData(stage) {
  const normalized = stage?.toLowerCase()?.trim();
  return HAIR_STAGE_TAG_MAP[normalized] || { title: stage, image: "" };
}

// ── HAIR FALL INTENSITY MAP ────────────────────────────────────────────────
const HAIR_FALL_INTENSITY_MAP = {
  "normal hair fall": {
    title: "Normal Hair Fall",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/normal-hair-fall.webp"
  },
  "excessive hair fall": {
    title: "Excessive Hair Fall",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/excessive_hair_fall_aee042aa-1677-4c32-b207-0f77aa3ae5ba.webp"
  },
  "severe hair fall": {
    title: "Severe Hair Fall",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/severe_hair_fall_c8c464a4-5342-4b4e-ba53-6bf583ade2ed.webp"
  }
};

function getHairFallData(intensity) {
  const normalized = intensity?.toLowerCase()?.trim();
  return HAIR_FALL_INTENSITY_MAP[normalized] || { title: intensity, image: "" };
}

function showContent(response) {
  var normalPage = document.querySelectorAll('[page_type="normal"]');
  var cuticlePage = document.querySelectorAll('[page_type="cuticle"]');
  var { User_Analysis, Recommendations, stageTransition, assessmentReport, hideAssesmentImage } = response;
  const userNameEls       = document.querySelectorAll('#user-name');
  const reportStageContent = document.querySelector('#hair-condition');
  const hairFallCondition  = document.querySelector('#hair-fall-condition');
  if (userNameEls.length) {
    userNameEls.forEach((name) => {
      name.innerHTML = `
        <div class="hair-snapshot-greeting-wrap">
          <div class="hair-snapshot-greeting">Hi, <span>${User_Analysis.first_name}</span></div>
        </div>
        <b class="hair-snapshot-subtitle">We know exactly what's happening with your hair</b>
      `;
    });
  }

  function formatTitle(title) {
    if (!title) return '';
    const spaceIdx = title.indexOf(' ');
    if (spaceIdx === -1) return title; // single word, nothing to split
    return `${title.slice(0, spaceIdx)}<span class="title-br"><br></span>${title.slice(spaceIdx + 1)}`;
  }

  if (reportStageContent) {
    const data = getHairConditionData(User_Analysis.hair_fall_stage);
    reportStageContent.innerHTML = `
      ${data.image ? `<img src="${data.image}" alt="${data.title}" class="hair-snapshot-card-icon" width="40" height="40" />` : ""}
      <div class="hair-snapshot-card-text">${formatTitle(data.title)}</div>
    `;
  }

  if (hairFallCondition) {
    const data = getHairFallData(User_Analysis.hairFallIntensity);
    hairFallCondition.innerHTML = `
      ${data.image ? `<img src="${data.image}" class="hair-snapshot-card-icon" width="40" height="40" />` : ""}
      <div class="hair-snapshot-card-text">${formatTitle(data.title)}</div>
    `;
  }
  
  var RootCauses = response.root_causes.primaryRootCause[0];
  var User_Analysis_hair_fall =  User_Analysis.hair_fall_stage;
  const newHairFallStage = User_Analysis_hair_fall;
  const hairThinningWeekText = document.querySelector('.hair_thinning_week_text-container');
  const hairThinningWeekText2 = document.querySelector('.hair_thinning_week_text-container.d-md-none');
  const removeCustomPriceSection = document.querySelector('.custom-price-section');
  var tillImage = document.querySelector(".tillImage img"), toImage = document.querySelector(".toImage img"), toStageWiseimg = document.querySelector(".stageWise-img"),
    assist_report = document.querySelector(".assist_report strong"), mobileDescription = document.querySelector(".mobileDescription"),
     desktopDescription = document.querySelector(".desktopDescription");
    if (hideAssesmentImage === true) {
      if (toStageWiseimg) {
        toStageWiseimg.style.cssText = "display: none;";
      }
    } else {
      if(tillImage) tillImage.setAttribute("src", stageTransition.current);
      if(toImage) toImage.setAttribute("src", stageTransition.getYouHere);
    }
  if(User_Analysis_hair_fall.toLowerCase() === "coin size patches") {
    var toImageParent = document.querySelector(".toImage"), arrowImage = document.querySelector(".stageWise-img .arrow"), stageWiseimg = document.querySelector(".stageWise-img");
    if(toImageParent) toImageParent.classList.add("d-none");
    if(arrowImage) arrowImage.classList.add("d-none");
    if(stageWiseimg) stageWiseimg.classList.add("justify-content-center");
  }
  if(assist_report) assist_report.innerHTML = User_Analysis_hair_fall;
  const defaultText = "While coin size patches cannot be cured, we offer a kit to help maintain your hair. Results may be limited due to the advanced stage of female hair loss, but we are here to support you.";
  const isCoinSizePatches = User_Analysis_hair_fall.toLowerCase() === "coin size patches";
  // if (!isCoinSizePatches) {
  //   if (isValidChatCase && isLessThan6Months) {
  //      displayText = `<span class="highlight-text">Act now before it gets worse.</span>`;
  //   } else {
  //     displayText = assessmentReport?.assessmentReport?.replace(/\n/g, "<br>");
  //   }
  // } else {
  //   displayText = defaultText;
  // }

   const displayText = isCoinSizePatches ? defaultText : assessmentReport?.assessmentReport?.replace(/\n/g, "<br>");

  if (mobileDescription) mobileDescription.innerHTML = displayText;
  if (desktopDescription) desktopDescription.innerHTML = displayText;
  if (User_Analysis_hair_fall == "No widening" || User_Analysis_hair_fall == "Starting to see widening") {
    let product_card_head = document.querySelectorAll(".product-section_heading-kit");
    product_card_head.forEach((e) => {
      if (window.innerWidth < 768) {
        e.innerHTML = "Your Customised <br> Hair Treatment Kit";
      } else {
        e.textContent = "Your Customised Hair Treatment Kit";
      }
    });
  }
  
  f_name = User_Analysis.first_name; 
  C_number = User_Analysis.phone; 
  strikeFinalCartPrice =  Math.round(response.newPriceCard.updatedCartPrice); 
  setCookie('user_phone', C_number, 30)
  C_email = User_Analysis.email;
  user__gender = User_Analysis.gender;
  caseId = User_Analysis.case_id;
  localStorage.setItem('caseId', caseId);
  tagClarityCaseId(caseId);
  if(user__gender == 'F') {
    user_gender = 'Female';
  }
    displayStageSection(response);
    initSomeoneLikeYouV2(response);
    productComboKit(response);
    optionalAddOnProducts(response);
    getProductByHandle(response);
    const timeline = getTimelineData(response);
    initResultsTimeline(response);
    if (typeof initResultsPopup === "function") initResultsPopup();
    renderTimeline(timeline, ".rt-timeline-wrapper");
    headerLanguageSelectorFR5(User_Analysis_hair_fall);
    // initBannerPopup();  
    // initClinicalEntryV3Popup();
    // initClinicalPopup();
    setupTrayaForeverFaq(caseId, response);
    initResultsProgressBar(response);
    initTrayaScienceV2BannerPopup();   // ← add this line
    languageSelection();
    let goal = User_Analysis.goal;
    if(goal != null && goal != 'undefined'){
      goal = goal.replace('{"',"").replace(/","/g,", ").replace(/Anti-/g,'').replace(/More/g,'').replace('"}',"")
    }else {
     goal = 'Goal';
    }
    var root_cause = `Gut:${User_Analysis.gut}, Stress:${User_Analysis.stress}`, suffering_data = User_Analysis.suffering_from_conditions,
      hair_type = User_Analysis.hair_type, Stress = User_Analysis.stress, Genetics = User_Analysis.family_genetic,
      FamilyGenetics = User_Analysis.family_genetic, EnergyLevel = User_Analysis.energy_level, Digestion = User_Analysis.acidity_bloating_gas_indigestion,
      Lowthyroid = User_Analysis.suffering_from_conditions, vitamindefeciencies = User_Analysis.vitamin_defeciencies,
      show_treatment_months = response.show_treatment_months;
    if(show_treatment_months == true){
      var _newFresult = document.querySelectorAll('.new-fresult'), __customEssential = document.querySelectorAll('.custom-essential'),
        __female_concern_months = document.querySelectorAll('.female_concern_months'), __container_will_see = document.querySelectorAll('.container.will-see');
      if(_newFresult.length != 0) {showOrHideByClass(_newFresult, 'add', 'new-fresult_pd_true');}
      if(__customEssential.length != 0) {showOrHideByClass(__customEssential, 'add', 'custom_essential_pd_true');}
      if(__female_concern_months.length != 0) {
        showOrHideByClass(__female_concern_months, 'add', 'female_months_show');
        showOrHide(__female_concern_months, 'block');
      }
      if(__container_will_see.length != 0) {showOrHide(__container_will_see, 'none');}
    }
    var user__name = document.querySelectorAll('[data-user-name]'), __data_user_name_info = document.querySelectorAll('[data-user-name-info]'),
      scalpType = document.querySelectorAll('.femleBannerTTls [scalp-type]'), __hair_concern = document.querySelectorAll('.femleBannerTTls [hair-concern]'),
      __root__cause = document.querySelectorAll('.femleBannerTTls [root-cause]'), __primary_root = document.querySelectorAll('[primary-root]'),
      __mainFactImages = document.querySelectorAll('.root_cause_iconFR .mainFactImages'), __femaleMainFactImages = document.querySelectorAll('.root_cause_iconFRs .mainFactImages'),
      __rootcause_description = document.querySelectorAll('.RootCause .rootcause_description'), __formulation = document.querySelectorAll('.formulation .formulation-text');
    if(user__name.length != 0){user__name.forEach((name) => {name.textContent = `${User_Analysis.first_name}`});}
    if(__data_user_name_info.length != 0) {__data_user_name_info.forEach((info) => {info.textContent = `${User_Analysis.first_name}'s`})}
    if(scalpType.length != 0) {scalpType.forEach((scalp) => {scalp.textContent = `${User_Analysis.hair_type}`})}
    if(__hair_concern.length != 0) {__hair_concern.forEach((concern) => {concern.textContent = `${goal}`})}
    if(__root__cause.length != 0) {__root__cause.forEach((cause) => {cause.textContent = `${factors[0]}`})}
    if(__primary_root.length != 0) {__primary_root.forEach((root) => {root.textContent = `${factors[0]}`})}
    if(__mainFactImages.length != 0) {showOrHide(__mainFactImages, 'none');}
  
    var ATC_frp = document.querySelectorAll('#add-to-cart-result-page-frp'), stickyATC_frp = document.querySelectorAll('.sticky-btn #add-to-cart-result-page-frp'),
      ATC_rp = document.querySelectorAll('.add-to-cart-result-page');
    if(ATC_frp.length != 0) {
      ATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(stickyATC_frp.length != 0) {
      stickyATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(ATC_rp.length != 0) {
      ATC_rp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
  
  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.addEventListener('click', () => {
       eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" class="loader-icon" alt="Loading...">`;
       eachBtn.classList.add('loader-added')
       eachBtn.disabled = true;
       trackMetaEvent(response.User_Analysis, "Expand Benefits");
      const cta_label = eachBtn.textContent.trim() || 'Buy Now';
      const rawGender = response?.User_Analysis?.gender || '';
      const gender =
        rawGender === 'F' ? 'Female' : rawGender === 'M' ? 'Male' : rawGender;

      const caseId = response?.User_Analysis?.case_id || '';
      const eventPayload = {
        cta_label,
        gender,
        case_id: caseId,
        page_url: window.location.href,
      };
      if (typeof gtag === 'function') {
        gtag('event', 'buy_now_click', {
          send_to: 'G-KJK84KP0LJ',
          ...eventPayload,
        });
      }
      if (window.umami?.track) {
        window.umami.track('buy_now_click', { ...eventPayload, fingerprintId: window.__deviceId });
      }
       fireResultsBuyNowEvent(response);
      setTimeout(() => {
        if (window.appliedReferralCode) {
          window.location.href = `/checkout?discount=${window.appliedReferralCode}`;
        } else {
          window.location.href = '/checkout';
        }
      }, 100);
       setTimeout(() => {
         removeLoader();
      }, 2000);
    });
  });

  const resultsUiUpdateBtn = document.querySelector('.results-ui-update');
  const cliniclEntryV3     = document.querySelector('.clinical-entry-v3');
  const cev3CtaBtn         = document.querySelector('.cev3-cta-button');
  const cev3ImageWraps     = document.querySelectorAll('.cev3-card-image-wrap, .cev3-slide');

  if (resultsUiUpdateBtn || cliniclEntryV3) {
    const clinicalOverlay  = document.querySelector('.clinical-overlay');
    const clinicalPopup    = document.querySelector('.clinical-popup');
    const popupContent     = document.querySelector('.clinical-popup-content');
    const clinicalCloseBtn = document.querySelector('.clinical-close');
    const clinicalClose    = document.querySelector('.clinical-close-button');

    let cachedHTML   = null;
    let fetchPromise = null;

    function fetchClinicalPage() {
      if (fetchPromise) return fetchPromise;
      fetchPromise = fetch('/pages/clinical-study-v2')
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          cachedHTML = (doc.querySelector('main') || doc.body).innerHTML;
          return cachedHTML;
        })
        .catch(err => { console.error('Clinical page load failed:', err); fetchPromise = null; });
      return fetchPromise;
    }

    // prefetch immediately
    fetchClinicalPage();

    function openClinicalPopup() {
      fireClinicEvent("Clinical_study_entry_clicked", caseId);
      fetchClinicalPage().then(() => {
        if (!clinicalOverlay || !clinicalPopup || !popupContent) return;
        popupContent.innerHTML = cachedHTML;
        initClinicalSlider('.journey-slider');
        initClinicalSlider('.data-slider');
        clinicalOverlay.classList.add('active');
        clinicalPopup.classList.add('active');
        clinicalPopup.scrollTop = 0;
        popupContent.scrollTop  = 0;
      });
    }

    function closeClinicalPopup() {
      if (clinicalOverlay) clinicalOverlay.classList.remove('active');
      if (clinicalPopup)   clinicalPopup.classList.remove('active');
    }

    // Triggers — top bar (D+ users)
    if (resultsUiUpdateBtn) {
      resultsUiUpdateBtn.addEventListener('click', openClinicalPopup);
    }

    // Triggers — V3 CTA button
    if (cev3CtaBtn) {
      cev3CtaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openClinicalPopup();
      });
    }

    // Triggers — V3 image cards
    cev3ImageWraps.forEach(function (el) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        openClinicalPopup();
      });
    });

    // Close handlers
    if (clinicalCloseBtn) clinicalCloseBtn.addEventListener('click', closeClinicalPopup);
    if (clinicalClose)    clinicalClose.addEventListener('click', closeClinicalPopup);
    if (clinicalOverlay)  clinicalOverlay.addEventListener('click', closeClinicalPopup);
  }

  const cards = document.querySelectorAll("[data-card]");
  cards.forEach(card => {
    const video = card.querySelector("[data-video]");
    const videoURL = video.dataset.videoUrl;
    const playBtn = card.querySelector("[data-play]");
    const videoTitle = card.querySelector(".real-story-thumb")?.getAttribute("alt") || "Real Story Video";
    playBtn.addEventListener("click", () => {
      fireVideoEvent("Video_thumbnail_clicked", caseId, videoURL, videoTitle);
    });
  });

  // Testimonial autoplay experience (50% experiment: caseId 0-3, hair/side thinning)
  initTestimonialAutoplay(caseId, userHairStage);

  // chat flotie js
  const fabWrapper = document.querySelector('.whats-app-wrapper-normal-user');
  const fabButton = document.getElementById('fabMainButton');
  const actionItems = document.querySelectorAll('.fab-action-item');

  if (!fabWrapper || !fabButton) return;

  let isExpanded = false;

  // Toggle FAB (open / close via main button)
  fabButton.addEventListener('click', function (e) {
    e.stopPropagation();

    fabWrapper.classList.toggle('expanded');
    isExpanded = fabWrapper.classList.contains('expanded');

    if (isExpanded) {
      chatIconClicked("web_floating_icon_clicked", caseId);
    } else {
      chatIconClicked("floating_icon_closed", caseId);
    }
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (isExpanded && !fabWrapper.contains(e.target)) {
      fabWrapper.classList.remove('expanded');
      isExpanded = false;
      chatIconClicked("floating_icon_closed", caseId);
    }
  });

  // CTA clicks (Chat / Book a Call)
  actionItems.forEach(item => {
    item.addEventListener('click', function (e) {
      e.stopPropagation();

      let ctaClicked = '';
      if (item.classList.contains('whatsapp-btn')) {
        ctaClicked = 'chat with us';
      } else if (item.classList.contains('book-call-btn')) {
        ctaClicked = 'book a call';
      }

      fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
        },
        body: JSON.stringify({
          "eventName": "floating_icon_cta_clicked",
          "eventAttributes": {
            "generalAttributes": {
              "platform": "web_shopify",
              "domain": "traya.health",
              "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id",
              "cta_clicked": ctaClicked
            }
          },
          "caseId": caseId
        })
      });

    });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isExpanded) {
      fabWrapper.classList.remove('expanded');
      isExpanded = false;
      chatIconClicked("floating_icon_closed", caseId);
    }
  });
  // initClinicalPopup();
}

function initClinicalSlider(selector){
  const $slider = $(selector);
  if(!$slider.hasClass('slick-initialized')){
    $slider.on('init reInit afterChange', function(event, slick, currentSlide){
      const current = currentSlide ? currentSlide : 0;
      const total = slick.slideCount;
      const dots = this.querySelectorAll('.slick-dots li');
      dots.forEach((dot,index)=>{
        const button = dot.querySelector('button');
        if(index === current){
          button.innerHTML = `${current+1}/${total}`;
          dot.classList.add('slick-counter-active');
        }else{
          button.innerHTML = '';
          dot.classList.remove('slick-counter-active');
        }
      });

    });
    $slider.slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2.6,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
  }
}

// function fireChatFlotieEvent(eventName, caseID) {
function chatIconClicked(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}


function fireExpectationEvent(eventName, caseID, selectedMonth) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "Number of the month clicked": selectedMonth,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function fireVolumeEvent(caseID, volumeCta) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": "testimonial_carousel_volume_clicked",
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "volume_cta": volumeCta,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

// female-result4 "Real women, Real stories" viewport-autoplay + testimonial overlay.
// Gated to the experiment cohort; the control cohort keeps the default click-to-play.
function initTestimonialAutoplay(caseId, stage) {
  const eligibleStage = ['hair thinning', 'side thinning'].includes((stage || '').toLowerCase());
  // Experiment cohort: caseId starting 0-3, hair-thinning / side-thinning only.
  const eligibleCase = caseId && /^[89ab]/.test(String(caseId));
  if (!eligibleStage || !eligibleCase) return;

  const wrapper = document.querySelector('.real-stories-wrapper');
  const slider = document.querySelector('.real-stories-slider');
  if (!wrapper || !slider) return;

  // Slick is initialised in the section's own DOMContentLoaded handler — wait for it.
  if (typeof $ === 'undefined' || !$(slider).hasClass('slick-initialized')) {
    return setTimeout(() => initTestimonialAutoplay(caseId, stage), 300);
  }

  wrapper.classList.add('rs-autoplay-mode');

  const cards = Array.from(wrapper.querySelectorAll('[data-card]'));
  if (!cards.length) return;

  let isMuted = false; // autoplay with sound; browser blocks sound until the user interacts
  let sectionSeen = false;
  let userActivated = false; // set true after the first real user gesture (enables sound-on play)

  function getCardByIndex(index) {
    // Slick adds .slick-slide / data-slick-index directly onto the [data-card] element,
    // so the slide element IS the card — not a wrapper around it.
    return slider.querySelector('.slick-slide[data-slick-index="' + index + '"]');
  }

  function resetCard(card) {
    if (!card) return;
    const v = card.querySelector('[data-video]');
    const thumb = card.querySelector('.real-story-thumb');
    const playBtn = card.querySelector('[data-play]');
    const pauseBtn = card.querySelector('[data-pause]');
    if (v) { v.pause(); v.style.display = 'none'; }
    if (thumb) thumb.style.display = 'block';
    if (playBtn) playBtn.style.display = 'flex';
    if (pauseBtn) pauseBtn.classList.remove('show');
  }

  // Reflect the actual muted state of the currently playing video on every volume icon.
  function reflectMute(video) {
    const muted = video ? video.muted : isMuted;
    wrapper.querySelectorAll('[data-volume]').forEach(btn => {
      btn.classList.toggle('is-muted', muted);
    });
  }

  function playCard(card) {
    if (!card) return;
    cards.forEach(c => { if (c !== card) resetCard(c); });
    const v = card.querySelector('[data-video]');
    const thumb = card.querySelector('.real-story-thumb');
    const playBtn = card.querySelector('[data-play]');
    if (!v) return;
    if (!v.src) v.src = v.dataset.videoUrl;
    // Play with sound once the user has interacted; before that the browser forces muted autoplay.
    v.muted = isMuted || !userActivated;
    v.setAttribute('playsinline', '');
    if (thumb) thumb.style.display = 'none';
    if (playBtn) playBtn.style.display = 'none';
    v.style.display = 'block';
    const p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {
        // Browser blocked sound-on autoplay (no user gesture yet) → play muted so it doesn't
        // freeze. Only this video is muted; the user's intent (isMuted) is left unchanged so a
        // later swipe/gesture still plays with sound, and the icon reflects the real state.
        v.muted = true;
        reflectMute(v);
        const p2 = v.play();
        if (p2 && typeof p2.catch === 'function') p2.catch(() => resetCard(card));
      });
    }
  }

  // Keep the overlay bound to whatever video is actually playing, regardless of
  // whether playback was triggered by autoplay, a swipe, or the existing click-to-play.
  cards.forEach(card => {
    const v = card.querySelector('[data-video]');
    if (!v) return;
    v.addEventListener('play', () => {
      cards.forEach(c => c.classList.remove('rs-active'));
      card.classList.add('rs-active');
      reflectMute(v);
    });
    v.addEventListener('pause', () => card.classList.remove('rs-active'));
    v.addEventListener('ended', () => card.classList.remove('rs-active'));
  });

  // Volume mute/unmute — toggles relative to the current video's real state, fires analytics.
  wrapper.querySelectorAll('[data-volume]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const active = wrapper.querySelector('.real-story-card.rs-active [data-video]')
        || wrapper.querySelector('[data-video]');
      isMuted = active ? !active.muted : !isMuted;
      wrapper.querySelectorAll('[data-video]').forEach(v => { v.muted = isMuted; });
      reflectMute(active);
      fireVolumeEvent(caseId, isMuted ? 'mute' : 'unmute');
    });
  });
  reflectMute(null);

  // Before the user's first interaction the browser blocks sound-on autoplay, so the first video
  // plays muted. Record the first real gesture (tap/click/key) as activation — even if it happens
  // while scrolling toward the section, before the video plays — then unmute any video already
  // playing and let future plays (swipes / the still-to-come first video) start with sound.
  const onFirstGesture = () => {
    userActivated = true;
    if (!isMuted) {
      const active = wrapper.querySelector('.real-story-card.rs-active [data-video]');
      if (active && active.muted) { active.muted = false; reflectMute(active); }
    }
    document.removeEventListener('pointerdown', onFirstGesture);
    document.removeEventListener('touchstart', onFirstGesture);
    document.removeEventListener('keydown', onFirstGesture);
  };
  document.addEventListener('pointerdown', onFirstGesture);
  document.addEventListener('touchstart', onFirstGesture, { passive: true });
  document.addEventListener('keydown', onFirstGesture);

  // Autoplay the first video only once the section is scrolled into view.
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !sectionSeen) {
        sectionSeen = true;
        playCard(cards[0]);
        observer.disconnect();
      }
    });
  }, { threshold: 0.4 });
  observer.observe(wrapper);

  // Pause the outgoing video as soon as a slide transition starts.
  $(slider).on('beforeChange', function () {
    if (!sectionSeen) return;
    cards.forEach(c => {
      const v = c.querySelector('[data-video]');
      if (v && !v.paused) resetCard(c);
    });
  });

  // Swiping / moving to another slide autoplays the now-current video (previous one stops).
  $(slider).on('afterChange', function (event, slick, currentSlide) {
    if (!sectionSeen) return;
    const currentCard = slider.querySelector('.slick-current') || getCardByIndex(currentSlide);
    playCard(currentCard);
  });
}

function fireVideoEvent(eventName, caseID, videoURL, videoTitle) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "videoURL": videoURL,
          "videoTitle": videoTitle,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function fireMiniVideoEvent(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function initResultsTimeline(response) {
  function getTimelineData(response) {
    const resultsTimeline = {
      nonDandruff: [
        { month: "Kit-1", heading: "Scalp health improves", 
          subheading: "Your scalp is being nourished & balanced, so it is ready for the solution.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803", 
          milestone: false
        },
        { month: "Kit-2", heading: "Weak detached hair falls", 
          subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793", 
          milestone: false 
        },
        { month: "Kit-3", heading: "Hair fall under Control", 
          subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850", 
          milestone: true 
        },
        { month: "Kit-4", heading: "Faster Hair Growth", 
          subheading: "Your hair grows at a healthy speed and starts feeling softer & smoother.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899", 
          milestone: false 
        },
        { month: "Kit-5", heading: "Thick Dense Hair, Fuller Scalp", 
          subheading: "Your scalp starts feeling fuller as hairfall is less & hair growth is fast", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986", 
          milestone: true },
        { month: "Traya for life", heading: "Healthy Hair - Strong from Root", 
          subheading: "Continue maintaining your hair with Traya serum and oil for continued results.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000",
          milestone: false 
        }
      ],
      dandruff: [
        { month: "Kit-1", heading: "Visible dandruff reduction", 
          subheading: "Dandruff clears up so your scalp is cleaner and less irritated", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_0.webp?v=1770014538", 
          milestone: false 
        },
        { month: "Kit-2", heading: "Scalp health improves further", 
          subheading: "Your scalp is being nourished & balanced, so it is ready for the treatment", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803", 
          milestone: false 
        },
        { month: "Kit-3", heading: "Weak detached hair falls", 
          subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793", 
          milestone: false 
        },
        { month: "Kit-4", heading: "Hair fall under control", 
          subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850", 
          milestone: true 
        },
        { month: "Kit-5", heading: "Faster Hair Growth", 
          subheading: "Your hair grows at a healthy speed and starts feeling softer & smoother.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899", 
          milestone: false 
        },
        { month: "Kit-6", heading: "Thick Dense Hair, Fuller Scalp", 
          subheading: "Your scalp starts feeling fuller as hairfall is less & hair growth is fast", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986", 
          milestone: true 
        },
        { month: "Traya for life", heading: "Healthy Hair - Strong from Root", 
          subheading: "Continue maintaining your hair with Traya serum and oil for continued results.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000", 
          milestone: false 
        }
      ],
      experimentNonDandruff: [
        { month: "Kit-1", heading: "Scalp health improves", 
          subheading: "Your scalp is being nourished & balanced, so it is ready for the solution.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803", 
          milestone: false
        },
        { month: "Kit-2", heading: "Weak detached hair falls", 
          subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793", 
          milestone: false 
        },
        { month: "Kit-3", heading: "Hair fall under Control", 
          subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850", 
          milestone: true 
        },
        { month: "Kit-4", heading: "Faster Hair Growth", 
          subheading: "Your hair grows at a healthy speed and starts feeling softer & smoother.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899", 
          milestone: false 
        },
        { month: "Kit-5", heading: "Thick Dense Hair, Fuller Scalp", 
          subheading: "Your scalp starts feeling fuller as hairfall is less & hair growth is fast", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986", 
          milestone: true },
        { month: "Traya for life", heading: "Healthy Hair - Strong from Root", 
          subheading: "Continue maintaining your hair with Traya serum and oil for continued results.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000",
          milestone: false 
        }
      ],
      experimentDandruff: [
        { month: "Month-1", heading: "Scalp Health Improves",
          subheading: "Your scalp is being nourished & balanced, so it is ready for the solution",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803",
          milestone: false
        },
        { month: "Month-2", heading: "Dandruff cleared",
          subheading: "Your scalp is now ready for further treatment.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month.webp?v=1783490736",
          milestone: true
        },
        { month: "Month-3", heading: "Weak detached hair falls",
          subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793",
          milestone: false
        },
        { month: "Month-4", heading: "Hair fall under Control", 
          subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850", 
          milestone: true 
        },
        { month: "Month-5", heading: "Faster Hair Growth", 
          subheading: "Your hair grows at a healthy speed and starts feeling softer & smoother.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899", 
          milestone: false 
        },
        { month: "Month-6", heading: "Thick Dense Hair, Fuller Scalp", 
          subheading: "Your scalp starts feeling fuller as hairfall is less & hair growth is fast", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986", 
          milestone: true },
        { month: "Traya for life", heading: "Healthy Hair - Strong from Root", 
          subheading: "Continue maintaining your hair with Traya serum and oil for continued results.", 
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000",
          milestone: false 
        }

      ]
    };

    const caseId = response?.User_Analysis?.case_id || response?.caseId || "";
    const casePrefix = String(caseId).charAt(0).toLowerCase();
    const EXPERIMENT_PREFIXES = ["4", "5", "6", "7"];
    const isExperimentUser = EXPERIMENT_PREFIXES.includes(casePrefix);
    const defaultRC = response?.root_causes?.defaultRootCause || [];
    const primaryRC = response?.root_causes?.primaryRootCause || [];
    const allRootCauses = [...defaultRC, ...primaryRC];

    const hasDandruff = allRootCauses.some(rc =>
      rc?.key?.toLowerCase().includes("dandruff")
    );

    console.log("[Timeline] caseId:", caseId, "prefix:", casePrefix, 
                "isExperimentUser:", isExperimentUser, 
                "hasDandruff:", hasDandruff);

    if (isExperimentUser) {
      if(hasDandruff){document.querySelector(".alert-tab-animation").classList.remove('d-none');}
      return hasDandruff
        ? resultsTimeline.experimentDandruff
        : resultsTimeline.experimentNonDandruff;
    }

    return hasDandruff
      ? resultsTimeline.dandruff
      : resultsTimeline.nonDandruff;
  }

  const monthEl = document.getElementById("rtpMonth");
  const titleEl = document.getElementById("rtpTitle");
  const descEl  = document.getElementById("rtpDesc");
  const curveEl = document.getElementById("rtpCurve");
  const imageBox = document.querySelector(".rtp-image-placeholder");
  const milestoneTextBox = document.querySelector(".rtp-milestone-achive-text");
  const milestoneNumberEl = document.getElementById("milestoneNumber");

  if (!monthEl || !titleEl || !descEl || !curveEl) return;

  const data = getTimelineData(response);
  
  // Get milestone indices and count
  const milestoneIndices = [];
  data.forEach((item, index) => {
    if (item.milestone) {
      milestoneIndices.push(index);
    }
  });

  // Auto-click state management
  let autoClickInterval = null;
  let currentIndex = 0;
  let isAutoClicking = true;
  let confettiShown = new Set(); // Track which milestones have shown confetti during auto-play
  let confettiTimeout = null; // Track confetti timeout

  function updateContent(index, isManualClick = false) {
    const item = data[index];
    const section = document.querySelector(".results-timeline-progress");
    const rtpContainer = document.querySelector(".rtp-container");

    monthEl.textContent = item.month;
    titleEl.textContent = item.heading;
    descEl.textContent  = item.subheading;

    if (item.image) {
      imageBox.src = item.image;
    }
    if (isManualClick) {
      fireExpectationEvent("expectation_setting_clicked_rp", caseId, `month-${index + 1}`);
    }
    // Update active node
    document.querySelectorAll(".rtp-node").forEach((el, i) => {
      el.classList.toggle("active", i === index);
    });

    document.querySelectorAll(".rtp-month-text").forEach((el, i) => {
      el.classList.toggle("show", i === index);
    });

    section.classList.remove("is-milestone");
    
    if (item.milestone && milestoneTextBox) {
      const milestoneNumber = milestoneIndices.indexOf(index) + 1;
      milestoneNumberEl.textContent = `Milestone #${milestoneNumber}`;
      milestoneTextBox.style.display = "flex";
      section.classList.add("is-milestone");

      // Show confetti logic:
      // - During auto-play: show only once per milestone
      // - On manual click: always show
      const shouldShowConfetti = isManualClick || !confettiShown.has(index);
      
      if (shouldShowConfetti) {
        // Track that we've shown this milestone during auto-play
        if (!isManualClick) {
          confettiShown.add(index);
        }
        
        // Clear any existing confetti timeout
        if (confettiTimeout) {
          clearTimeout(confettiTimeout);
        }
        
        // Remove existing confetti background
        rtpContainer.style.backgroundImage = 'none';
        
        // Trigger reflow to restart animation
        void rtpContainer.offsetWidth;
        
        // Add confetti background with cache-busting timestamp for manual clicks
        const confettiUrl = isManualClick 
          ? `url(https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_confetti-on-transparent-background-ajhx1TPBa7.gif?v=1770014641&t=${Date.now()})`
          : 'url(https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_confetti-on-transparent-background-ajhx1TPBa7.gif?v=1770014641)';
        
        rtpContainer.style.backgroundImage = confettiUrl;
        
        // Remove confetti after animation completes
        confettiTimeout = setTimeout(() => {
          rtpContainer.style.backgroundImage = 'none';
        }, 1200);
      }
    } else {
      milestoneTextBox.style.display = "none";
    }

    currentIndex = index;
  }

  function startAutoClick() {
    if (autoClickInterval) {
      clearInterval(autoClickInterval);
    }

    autoClickInterval = setInterval(() => {
      if (!isAutoClicking) {
        clearInterval(autoClickInterval);
        return;
      }

      currentIndex = (currentIndex + 1) % data.length;
      
      // Reset confetti tracking when loop starts over (back to index 0)
      if (currentIndex === 0) {
        confettiShown.clear();
      }
      
      updateContent(currentIndex);
    }, 3000);
  }

  function stopAutoClick() {
    isAutoClicking = false;
    if (autoClickInterval) {
      clearInterval(autoClickInterval);
      autoClickInterval = null;
    }
  }

  function renderTimeline() {
    curveEl.innerHTML = "";

    data.forEach((item, index) => {
      const nodeContainer = document.createElement("div");
      nodeContainer.style.position = "absolute";
      nodeContainer.style.bottom = "0";
      
      const node = document.createElement("div");
      node.className = "rtp-node"; 
      node.textContent = index + 1;

      if (item.milestone) {
        const flag = document.createElement("span");
        flag.className = "rtp-flag";
        flag.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_flag-animation-Y9v5xnRs1p.gif?v=1770014631" class="rtp-milestone-flag" width="auto" height="auto" alt="Milestone Flag">`;
        node.appendChild(flag);
      }

      const monthText = document.createElement("span");
      monthText.className = "rtp-month-text";
      monthText.textContent = "KIT";
      node.appendChild(monthText);
      
      node.addEventListener("click", () => {
        stopAutoClick(); // Stop auto-clicking when user clicks
        updateContent(index, true); // Pass true to indicate manual click
      });
      
      nodeContainer.appendChild(node);
      curveEl.appendChild(nodeContainer);
    });

    updateContent(0);
    // Auto-click will be started by Intersection Observer when section is in viewport
  }

  function positionNodesOnArc() {
    const nodes = document.querySelectorAll(".rtp-node");
    const total = nodes.length;
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      if (total === 6) {
        const mobilePositions = [
          { left: 9,  bottom: 34 },
          { left: 24, bottom: 55 },
          { left: 41, bottom: 67 },
          { left: 59, bottom: 67 },
          { left: 76, bottom: 56 },
          { left: 91, bottom: 30 }
        ];

        nodes.forEach((node, index) => {
          if (!mobilePositions[index]) return;
          node.parentElement.style.left = mobilePositions[index].left + "%";
          node.parentElement.style.bottom = mobilePositions[index].bottom + "px";
        });
      } else if (total === 7) {
        const mobilePositions7 = [
          { left: 7,  bottom: 28 },
          { left: 20, bottom: 48 },
          { left: 34, bottom: 60 },
          { left: 50, bottom: 66 },
          { left: 66, bottom: 60 },
          { left: 80, bottom: 48 },
          { left: 93, bottom: 28 }
        ];

        nodes.forEach((node, index) => {
          if (!mobilePositions7[index]) return;
          node.parentElement.style.left = mobilePositions7[index].left + "%";
          node.parentElement.style.bottom = mobilePositions7[index].bottom + "px";
        });
      }

      return;
    }

    const startX = 10;
    const endX   = 90;
    const minY   = 12;
    const maxY   = 100;

    nodes.forEach((node, index) => {
      const t = index / (total - 1);
      const x = startX + (endX - startX) * t;
      const y = minY + (4 * maxY * t * (1 - t));

      node.parentElement.style.left = x + "%";
      node.parentElement.style.bottom = y + "px";
    });

    if (total === 6) {
      nodes[0].parentElement.style.left = "11%";
      nodes[0].parentElement.style.bottom = "24px";
      nodes[total - 1].parentElement.style.left = "89%";
      nodes[total - 1].parentElement.style.bottom = "24px";
    } else if (total === 7) {
      nodes[0].parentElement.style.left = "10%";
      nodes[0].parentElement.style.bottom = "20px";
      nodes[total - 1].parentElement.style.left = "90%";
      nodes[total - 1].parentElement.style.bottom = "20px";
    }
  }

  renderTimeline();
  positionNodesOnArc();
  window.addEventListener("resize", () => {
    positionNodesOnArc();
  });

  // Intersection Observer to start auto-click when section is in viewport
  const section = document.querySelector(".results-timeline-progress");
  if (section) {
    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.3 // Trigger when 30% of the section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && isAutoClicking) {
          // Section is in viewport, start auto-clicking
          startAutoClick();
        } else if (!entry.isIntersecting && autoClickInterval) {
          // Section is out of viewport, pause auto-clicking
          clearInterval(autoClickInterval);
          autoClickInterval = null;
        }
      });
    }, observerOptions);

    observer.observe(section);
  }
}
function getTimelineData(response) {
  // ----------------------------------------
  // 1. Full timeline dataset
  // ----------------------------------------
  const resultsTimeline = {
    nonDandruff: [
      {
        month: "Month 1",
        heading: "Scalp health improves",
        subheading:
          "Your scalp is being nourished & balanced, so it is ready for the solution.",
        milestone: false
      },
      {
        month: "Month 2",
        heading: "Weak detached hair falls",
        subheading:
          "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks",
        milestone: false
      },
      {
        month: "Month 3",
        heading: "Hair fall under Control",
        subheading:
          "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots",
        milestone: true
      },
      {
        month: "Month 4",
        heading: "Faster Hair Growth",
        subheading:
          "Your hair grows at a healthy speed and starts feeling softer & smoother.",
        milestone: false
      },
      {
        month: "Month 5",
        heading: "Thick Dense Hair, Fuller Scalp",
        subheading:
          "Your scalp starts feeling fuller as hairfall is less & hair growth is fast",
        milestone: true
      },
      {
        month: '"Traya for life"',
        heading: "Healthy Hair - Strong from Root",
        subheading:
          "Continue maintaining your hair with Traya serum and oil for continued results.",
        milestone: false
      }
    ],

    dandruff: [
      {
        month: "Month 1",
        heading: "Visible dandruff reduction",
        subheading:
          "Dandruff clears up so your scalp is cleaner and less irritated",
        milestone: false
      },
      {
        month: "Month 2",
        heading: "Scalp health improves further",
        subheading:
          "Your scalp is being nourished & balanced, so it is ready for the treatment",
        milestone: false
      },
      {
        month: "Month 3",
        heading: "Weak detached hair falls",
        subheading:
          "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks",
        milestone: false
      },
      {
        month: "Month 4",
        heading: "Hair fall under control",
        subheading:
          "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots",
        milestone: true
      },
      {
        month: "Month 5",
        heading: "Faster Hair Growth",
        subheading:
          "Your hair grows at a healthy speed and starts feeling softer & smoother.",
        milestone: false
      },
      {
        month: "Month 6",
        heading: "Thick Dense Hair, Fuller Scalp",
        subheading:
          "Your scalp starts feeling fuller as hairfall is less & hair growth is fast",
        milestone: true
      },
      {
        month: '"Traya for life"',
        heading: "Healthy Hair - Strong from Root",
        subheading:
          "Continue maintaining your hair with Traya serum and oil for continued results.",
        milestone: false
      }
    ]
  };

  // ----------------------------------------
  // Correct root cause extraction
  // ----------------------------------------
  const defaultRC = response?.root_causes?.defaultRootCause || [];
  const primaryRC = response?.root_causes?.primaryRootCause || [];

  const allRootCauses = [...defaultRC, ...primaryRC];

  console.log("ALL ROOT CAUSES:", allRootCauses);

  // ----------------------------------------
  // Dandruff detection
  // ----------------------------------------
  const hasDandruff = allRootCauses.some(rc =>
    rc?.key?.toLowerCase().includes("dandruff")
  );

  console.log("HAS DANDRUFF?", hasDandruff);

  return hasDandruff
    ? resultsTimeline.dandruff
    : resultsTimeline.nonDandruff;
}

function renderTimeline(timelineData, containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) {
    console.warn("Timeline container not found:", containerSelector);
    return;
  }

  container.innerHTML = ""; // Clear previous content

  let milestoneCounter = 1;

  timelineData.forEach((item, index) => {

    let milestoneHTML = "";
    if (item.milestone) {
      milestoneHTML = `
        <div class="rt-milestone-felxer">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.66699 9.1663C2.66699 9.1663 3.33366 8.49963 5.33366 8.49963C7.33366 8.49963 8.66699 9.83297 10.667 9.83297C12.667 9.83297 13.3337 9.1663 13.3337 9.1663V1.99967C13.3337 1.99967 12.667 2.66634 10.667 2.66634C8.66699 2.66634 7.33366 1.33301 5.33366 1.33301C3.33366 1.33301 2.66699 1.99967 2.66699 1.99967V9.1663Z" fill="white" stroke="#F0F0F0" stroke-width="1.2"/>
            <path d="M2.66699 14.6667V9" stroke="#F0F0F0" stroke-width="1.2"/>
          </svg>
          <span class="rt-milestone">Milestone #${milestoneCounter}</span>
        </div>
      `;
      milestoneCounter++;
    }

    const card = `
      <div class="rt-item">
        <div class="rt-dot-line">
          <span class="rt-dot"></span>
          ${index !== timelineData.length - 1 ? `<span class="rt-line"></span>` : ""}
        </div>

        <div class="rt-content">
          <p class="rt-month">${item.month}</p>
          <h3 class="rt-heading rt-truncate">${item.heading}</h3>
          <p class="rt-subheading rt-truncate">${item.subheading}</p>

          ${milestoneHTML}
        </div>
      </div>
    `;

    container.insertAdjacentHTML("beforeend", card);
  });

  // ⭐ APPLY SLICK ONLY ON DESKTOP
  setTimeout(() => {
    if (window.innerWidth > 768) {
      if (!$(container).hasClass("slick-initialized")) {
        $(container).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          dots: false,
          infinite: false,
          pauseOnHover: false,
        })
        .on("afterChange", function (event, slick, currentSlide) {
          const lastSlide = slick.slideCount - slick.options.slidesToShow;

          if (currentSlide >= lastSlide) {
            // wait for autoplay delay, then restart from beginning
            setTimeout(() => {
              $(this).slick("slickGoTo", 0);
            }, slick.options.autoplaySpeed);
          }
        });

      }
    } else {
      // Mobile → destroy slick if it exists
      if ($(container).hasClass("slick-initialized")) {
        $(container).slick("unslick");
      }
    }
  }, 50); // small delay to ensure items are rendered
}

function isExactKitMatch(apiIds, kitIds) {
  if (apiIds.length !== kitIds.length) return false;

  return kitIds.every(id => apiIds.includes(String(id)));
}
function updateRegimenImages(section, kit) {
  if (!section) return;

  const img = section.querySelector('.regimen-mobile-img');
  const source = section.querySelector('.regimen-desktop-img');

  // ALWAYS update img (this is what browser finally renders)
  if (img) {
    img.src = kit.mobileImg;
    img.srcset = kit.mobileImg; // extra safety
  }

  // Update source for desktop
  if (source) {
    source.srcset = kit.desktopImg;
  }
}
function showRegimenSection(productData, kits) {
  if (!Array.isArray(productData) || !Array.isArray(kits)) return;

  const desktopSection = document.getElementById('regimen-2x2-desktop');
  const mobileSection = document.getElementById('regimen-2x2-mobile');

  // reset UI
  desktopSection?.classList.remove('is-visible');
  desktopSection?.classList.add('is-hidden');

  mobileSection?.classList.remove('is-visible');
  mobileSection?.classList.add('is-hidden');

  const recommendedVariantIds = productData.map(item =>
    String(item.product_id)
  );

  let matchedKit = null;
  for (const kit of kits) {
    if (
      isExactKitMatch(
        recommendedVariantIds,
        kit.variantIds.map(String)
      )
    ) {
      matchedKit = kit;
      break;
    }
  }

  console.log('Matched kit:', matchedKit?.id || 'NONE');

  if (!matchedKit) return;

  // 🔥 UPDATE IMAGES FOR BOTH SECTIONS
  updateRegimenImages(desktopSection, matchedKit);
  updateRegimenImages(mobileSection, matchedKit);

  // show only matched
  desktopSection?.classList.remove('is-hidden');
  desktopSection?.classList.add('is-visible');

  mobileSection?.classList.remove('is-hidden');
  mobileSection?.classList.add('is-visible');
}

const FEMALE_KITS = [
  {
    id: "kit1",
    variantIds: [47300731568306, 47302951403698, 45277154377906, 47301139169458, 47303097352370],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle1_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle1_desktop.webp"
  },
  {
    id: "kit2",
    variantIds: [47300731568306, 47302951403698, 45277154377906, 47303079166130, 47303097352370],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle2_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle2_desktop.webp"
  },
  {
    id: "kit3",
    variantIds: [46528923304114, 47302951403698, 45277154377906, 47303079166130, 47303097352370, 47301151064242],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle3_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle3_desktop.webp"
  },
  {
    id: "kit4",
    variantIds: [46528923304114, 47302951403698, 45277154377906, 47301139169458, 47303097352370, 47301151064242],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle4_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle4_desktop.webp"
  }
];

// ── SOMEONE LIKE YOU v2 (thinning) — 100% of thinning users (all case_ids) ──
// hair thinning / side thinning → show v2 (stage-matched card) and hide the old v1
// (#stageContainer). v1 markup is kept in place, just not shown. Any other stage →
// keep v1 (#stageContainer) visible, v2 stays hidden.
function initSomeoneLikeYouV2(response) {
  const section        = document.querySelector('section.sly');
  const stageContainer = document.getElementById('stageContainer');
  if (!section) return;

  const STAGE_TO_CARD = {
    'hair thinning': 'hair-thinning',
    'side thinning': 'side-thinning'
  };
  const stage       = (response?.User_Analysis?.hair_fall_stage || '').toLowerCase().trim();
  const targetStage = STAGE_TO_CARD[stage];

  // Non-thinning stage (widening / coin size / alopecia) → keep v1, v2 stays hidden.
  if (!targetStage) {
    section.hidden = true;
    return;
  }

  // Thinning → hide old v1 (kept in DOM, just not shown) and reveal v2's matching card.
  if (stageContainer) stageContainer.style.setProperty('display', 'none', 'important');
  section.querySelectorAll('.sly-card').forEach(card => {
    card.hidden = (card.dataset.stage !== targetStage);
  });
  section.hidden = false;
}

function displayStageSection(response) {
  // showRegimenSection(response.product_Ids, FEMALE_KITS);
  const stageImages = {
    "hair thinning": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_c2a537bc-4919-4b83-a12f-3767cb8d1b25.webp?v=1756899713",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_3bca6c41-ac7a-4ec8-9a57-43b2dd498985.webp?v=1756899713",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_7d151296-1377-4a5c-b218-da4db4a72c4c.webp?v=1756899713"
        
      ],
      customerName: "Sakshi"
    },
    "widening" : {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_906439c7-0777-4323-a6fb-54e2226571be.webp?v=1756899831",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_385b4e21-187d-4c80-bf27-4de49bb8b384.webp?v=1756899831",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1f4670c5-e3be-47a5-8890-fb50592e1dac.webp?v=1756899831"
      ],
      customerName: "Poonam"
    },
    "advanced widening": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_2_a6008d93-33ea-4539-a4f3-0a31b1e81546.webp?v=1756988341",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_2.webp?v=1756988341",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_5371c479-d809-4fc5-bd81-c1d1e6535b23.webp?v=1756988341"
      ],
      customerName: "Pratima"
    },
    "side thinning": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_0f684d2e-9d4b-4fc8-9c86-839c3d112433.webp?v=1756900221",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_a54b4d61-d7b0-449b-80a5-8b8c7aeb624c.webp?v=1756900221",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_0c8e0bca-7f44-40be-a1b5-5304dafe1c46.webp?v=1756900220"
      ],
      customerName: "Anjali"
    },
    "coin size patches": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_6041ce02-9314-4e64-8aff-668a3eba433a.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_dd3429b7-2edc-4dd8-8d98-bd019141c6c0.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_4aeb8cec-257c-454d-8434-548a24b29258.webp?v=1756900342"
      ],
      customerName: "Supriya"
    },
    "alopecia areata": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_6041ce02-9314-4e64-8aff-668a3eba433a.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_dd3429b7-2edc-4dd8-8d98-bd019141c6c0.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_4aeb8cec-257c-454d-8434-548a24b29258.webp?v=1756900342"
      ],
      customerName: "Supriya"
    }
  };

  const userStageRaw = response.User_Analysis.hair_fall_stage;
  const userStage = userStageRaw?.toLowerCase();
  console.log("User stage from response:", userStage);
  let stageData = null;
  for (const stageKey in stageImages) {
    if (stageKey.toLowerCase() === userStage) {
        stageData = stageImages[stageKey];
        break;
    }
  }
  console.log("User stage from response:", userStage);

  const stageContainer = document.getElementById("stageContainer");
  stageContainer.innerHTML = ""; 
  
  if (stageData && stageData.images.length > 0) {
    const p1 = document.createElement("p");
    p1.textContent = "Here’s someone like you";
    p1.className = "custome-stage-heading";
    stageContainer.appendChild(p1);

    const p2 = document.createElement("p");
    p2.textContent = `${stageData.customerName} was unsure, but she stayed consistent`;
    p2.className = "custome-stage-subheading";
    stageContainer.appendChild(p2);

    const imageWrapper = document.createElement("div");
    imageWrapper.className = "stage-image-wrapper";

    let arrowSvgImage = `<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M0.902344 16C0.902344 7.16344 8.06579 0 16.9023 0C25.7389 0 32.9023 7.16344 32.9023 16C32.9023 24.8366 25.7389 32 16.9023 32C8.06579 32 0.902344 24.8366 0.902344 16Z" fill="#EDD2CE"/>
        <path d="M13.7021 22.3984L20.1021 15.9984L13.7021 9.59844" stroke="#262626" stroke-width="1.6"/>
      </svg>`;

    stageData.images.forEach((imgUrl, index) => {
      const img = document.createElement("img");
      img.src = imgUrl;
      img.alt = userStage;
      img.className = "scrollable-stage-image";
      img.loading = "lazy";
      imageWrapper.appendChild(img);
    
      // Add arrow after each image except the last one
      if (index < stageData.images.length - 1) {
        const arrowWrapper = document.createElement("div");
        arrowWrapper.innerHTML = arrowSvgImage;
        arrowWrapper.className = "stage-arrow";
        imageWrapper.appendChild(arrowWrapper);
      }
    });
    
    stageContainer.appendChild(imageWrapper);
  }
}

function removeLoader() {
  let buyButtonLoader = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonLoader.forEach((eachBtn) => {
    eachBtn.innerHTML = "Buy Now";
    eachBtn.classList.remove('loader-added')
    eachBtn.disabled = false;
 });
}
  
function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}

function showOrHideByClass(partition, work, state) {
  partition.forEach((part) => {
    if(work == 'add') {part.classList.add(state)}
    if(work == 'remove') {part.classList.remove(state)}
  })
}

var prices = 0, variantsIDs = [];
function getProductByHandle(response) {
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let strikeTotalPrice = document.querySelectorAll('.strike-cart-total-price');
  const strikeFinalCartPrice = Math.round(response.cart_price);

  const internalProductCount = (response.product_Ids || []).filter(
    (each) => !isExternalProduct(each.product_id)
  ).length;

  window.internalKitCount = internalProductCount;
  const strikeMarkup = internalProductCount > 0 ? 699 : 499;

  if (strikeTotalPrice.length !== 0) {
    strikeTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${strikeFinalCartPrice + strikeMarkup}`;
    });
  }

  const finalCartPrice = Math.round(response.cart_price);
  if (resultTotalPrice.length != 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${finalCartPrice}`;
    });
  }
  let pricePerDay = document.querySelector('.recommend-price-perday price-perday');
  if (pricePerDay) {
    const perDayPriceValue = Math.round(finalCartPrice / 30);
    pricePerDay.innerText = `${perDayPriceValue}`;
  }
  applyOneMonthDiscount(response);
  updateSavedAmount();
}

const popOneLinerData = [
  {
    product: "Her Santulan",
    productVariantId: "46466095906994",
    effect: "Her Santulan supports daily wellness to maintain healthy hair.",
    ingredientName: "Shatavari | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair. | Calms scalp stress response, supporting healthier follicle activity and reduced hair fall.",
  },
  {
    product: "Mom Santulan for Postpartum hair",
    productVariantId: "46466402779314",
    effect: "Mom Santulan helps reduce post-partum hair fall.",
    ingredientName: "Vidarikand | Lodhra",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vidarikand.webp?v=1770375187 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Lodhra.webp?v=1770375186",
    ingredientContent: "Nourishes hair roots by supporting hormonal balance and tissue strength. | Helps balance scalp oiliness and supports a healthier follicle environment.",
  },
  {
    product: "Iron Santulan",
    productVariantId: "46465792704690",
    effect: "Iron Santulan helps reduce hair fall caused by anemia.",
    ingredientName: "Navayasa Loh | Pippali",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Navayasa.webp?v=1770375340 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365",
    ingredientContent: "Helps correct iron-related deficiencies that contribute to excessive hair fall. | Improves metabolism and circulation, helping nutrients reach hair follicles efficiently.",
  },
  {
    product: "PCOS Santulan",
    productVariantId: "42739969032370",
    effect: "PCOS Santulan helps to reduce hair fall caused by PCOS.",
    ingredientName: "",
    ingredientImage: "",
    ingredientContent: "",
  },
  {
    product: "Thyro Santulan",
    productVariantId: "46466225438898",
    effect: "Thyro Santulan helps reduce hair fall caused by thyroid issues.",
    ingredientName: "Chandraprabha Vati | Triphala",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Chandraprabhavati.png?v=1770375642 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Triphala.png?v=1758868752",
    ingredientContent: "Supports hormonal balance and metabolic health, helping reduce internally triggered hair fall. | Supports detox and nutrient absorption for healthier hair growth",
  },
  {
    product: "Gut Shuddhi",
    productVariantId: "46528902496434",
    effect: "Gut Shuddhi supports digestion to help reduce hair fall.",
    ingredientName: "Amla | Sunth",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802",
    ingredientContent: "Rich in antioxidants, strengthens hair roots and supports hair growth. | Enhances blood flow and nutrient delivery to support healthy hair growth.",
  },
  {
    product: "Digest boost for Improved Digestive Ability",
    productVariantId: "46528963936434",
    effect: "Digest Boost supports digestion to help reduce hair fall.",
    ingredientName: "Variyali | Ganthoda",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Variyali.webp?v=1770376077 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ganthoda.webp?v=1770376091",
    ingredientContent: "Improves digestion and reduces internal heat, supporting healthier hair growth from within. | Boosts circulation and digestion, supporting nourishment to hair follicles.",
  },
  {
    product: "Health Tatva",
    productVariantId: "47276523749554",
    effect: "Health Tatva helps in boosting metabolism.",
    ingredientName: "Sunth | Pippali",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365",
    ingredientContent: "Improves blood circulation and digestion, helping nutrients reach hair follicles effectively. | Improves metabolism and circulation, helping nutrients reach hair follicles efficiently.",
  },
  {
    product: "Hair Vitamin for her",
    productVariantId: "47303097352370",
    effect: "Hair Vitamin addresses nutritional deficiency to reduce hair fall.",
    ingredientName: "Biotin | Amino Acids",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Amino_Acids.webp?v=1770376900",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Build keratin structure, improving hair strength, thickness, and resistance to breakage.",
  },
  {
    product: "Hair Vitamin",
    productVariantId: "47303072710834",
    effect: "Hair Vitamin addresses nutritional deficiency to reduce hair fall.",
    ingredientName: "Biotin | Pumpkin Seed Extract",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pumpkin_Seed_Extract.png?v=1758868752",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Helps block DHT activity, supporting reduced hair thinning.",
  },
  {
    product: "Calm Ras",
    productVariantId: "47276517195954",
    effect: "Calm Ras helps to reduce hair fall caused by stress.",
    ingredientName: "Ashwagandha | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Prolongs hair growth phase and strengthens roots, supporting thicker and healthier hair regrowth.",
  },
  {
    product: "Nasal Ghrit",
    productVariantId: "47276533121202",
    effect: "Nasal Ghrit promotes better sleep to help reduce hair fall.",
    ingredientName: "Cow Ghee | Shatavari",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Cow_Ghee_1.png?v=1758868752 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027",
    ingredientContent: "Deeply moisturizes scalp and supports repair of dry, brittle hair shafts. | Supports hormonal balance and nourishment of hair follicles in women.",
  },
  {
    product: "Hair Ras",
    productVariantId: "46528906821810",
    effect: "Hair Ras provides essential nourishment for stronger, healthier hair.",
    ingredientName: "Ashwagandha | Bringhraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj.webp?v=1770379802",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Reduces stress hormones and improves scalp nourishment, helping control stress-related hair fall.",
  },
  {
    product: "Anti-Dandruff Shampoo",
    productVariantId: "47329496826034",
    effect: "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall.",
    ingredientName: "Ketocanozole 2% | AleoVera",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912",
    ingredientContent: "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss. | Helps reduce scalp dryness and flaking that can weaken hair roots.",
  },
  {
    product: "Recap Serum",
    productVariantId: "41645770309810",
    effect: "Recap Serum supports hair regrowth for fuller, healthier hair.",
    ingredientName: "",
    ingredientImage: "",
    ingredientContent: "",
  },
  {
    product: "Ketoconazole 2% night lotion",
    productVariantId: "46528923304114",
    effect: "Night Lotion fights dandruff to help reduce hair fall.",
    ingredientName: "Ketocanozole 2% | AleoVera",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912",
    ingredientContent: "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss. | Soothes irritated scalp and supports moisture balance for healthier hair growth.",
  },
  {
    product: "Scalp Oil 100ml with Dandruff Oil Shot",
    productVariantId: "46530320040114",
    effect: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Camphor | Castor oil",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/CastorOil.webp?v=1770297142",
    ingredientContent: "Improves scalp circulation and helps relieve itchiness linked to hair fall. | Nourishes scalp and supports thicker-looking hair by strengthening strands.",
  },
  {
    product: "Scalp Oil 100ml with Scalp Health Oil Shot",
    productVariantId: "46531529638066",
    effect: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Bergamot | ORPL",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bergamot.webp?v=1770380916 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ORPL.webp?v=1770380916",
    ingredientContent: "Helps balance oily scalp and supports a healthier scalp environment. | Helps improve hair fibre strength and reduces breakage from daily stress.",
  },
  {
    product: "Scalp Oil 100ml with Calm Oil Shot",
    productVariantId: "46530283012274",
    effect: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Coconut Oil | Amla",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_13.webp?v=1770381512 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815",
    ingredientContent: "Penetrates hair shaft to reduce protein loss and strengthen strands. | Rich in antioxidants, strengthens hair roots and supports hair density.",
  },
  {
    product: "Scalp Oil 100ml with Growth Oil Shot",
    productVariantId: "46530384527538",
    effect: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Camphor | Wheat Germ",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_14.webp?v=1770381631",
    ingredientContent: "Improves scalp circulation and helps relieve itchiness linked to hair fall. | Rich in vitamin E, supports scalp nourishment and hair strength.",
  },
  {
    product: "Nourish hair oil",
    productVariantId: "47302951403698",
    effect: "Nourish Oil deeply nourishes hair for strength and shine.",
    ingredientName: "Argan Oil | Rosemary Extract",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ArganOil.webp?v=1770297123 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Rosemary_Oil.png?v=1758868752",
    ingredientContent: "Rich in fatty acids, improves hair elasticity and reduces breakage. | Improves scalp circulation and supports thicker hair growth.",
  },
  {
    product: "Her Nourish",
    productVariantId: "47302857621682",
    effect: "Protects hair from harmonal hair fall",
    ingredientName: "Deodar | Latakranj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Deodar.webp?v=1770616150 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Latakranj.webp?v=1770616191",
    ingredientContent: "Helps reduce scalp inflammation and microbial buildup that can weaken hair roots. | Traditionally used to support hair pigmentation and reduce premature greying.",
  },
  {
    product: "Shine Leave in Serum",
    productVariantId: "47301148803250",
    effect: "Shine Serum enhances hair texture for a vibrant, healthy look.",
    ingredientName: "Dimethicone",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Dimethicone.webp?v=1770616417",
    ingredientContent: "Forms a protective layer to smooth hair and reduce friction-related breakage.",
  },
  {
    product: "Defence Shampoo 180ml",
    productVariantId: "47301151064242",
    effect: "Defence Shampoo ensures hair hygiene for a healthy scalp.",
    ingredientName: "Vitamin B3 | Biotin",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vitamin_B3.webp?v=1770616654 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883",
    ingredientContent: "Improves scalp blood circulation, supporting healthier hair follicles. | Supports keratin production, helping improve hair strength and thickness.",
  },
  {
    product: "Defence Conditioner",
    productVariantId: "44650256728242",
    effect: "Defence conditioner improves hair quality by deeply moisturizing the hair strands",
    ingredientName: "Biotin | Hydrolysed Rice protein",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Strengthens hair strands, improves elasticity, and reduces breakage.",
  },
  {
    product: "Defence Conditioner 50g",
    productVariantId: "45277154377906",
    effect: "Defence conditioner improves hair quality by deeply moisturizing the hair strands",
    ingredientName: "Biotin | Hydrolysed Rice protein",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Strengthens hair strands, improves elasticity, and reduces breakage.",
  },
  {
    product: "Consti Clear for Improved Bowel Movement",
    productVariantId: "47276511199410",
    effect: "Consti clear supports digestion to help reduce hair fall.",
    ingredientName: "",
    ingredientImage: "",
    ingredientContent: "",
  },
  {
    product: "Minoxidil 2%",
    productVariantId: "47329517568178",
    effect: "Minoxidil 2% promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 2% | Procapil 2%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Stimulates inactive follicles to support visible hair regrowth in early hair thinning. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 5%",
    productVariantId: "47302891929778",
    effect: "Minoxidil 5% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 5% | Procapil 3%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Strongly activates follicles to promote denser, faster hair regrowth. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 5% alc free",
    productVariantId: "46465512898738",
    effect: "Minoxidil 5% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 5% | Procapil 3%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Strongly activates follicles to promote denser, faster hair regrowth. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 2% alc free",
    productVariantId: "47276531417266",
    effect:"Minoxidil 2% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 2% | Procapil 2%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Stimulates inactive follicles to support visible hair regrowth in early hair thinning. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Hair Santulan 01",
    productVariantId: "47302996394162",
    effect: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Bhringraj | Shatavari",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027",
    ingredientContent: "Bhringraj prevents hair thinning and keeps the scalp free of dandruff and excess grease. | Supports hormonal balance and follicle nourishment, helping reduce female-pattern hair thinning.",
  },
  {
    product: "Hair Santulan 02",
    productVariantId: "47446793879730",
    effect:"Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Santulan 03",
    productVariantId: "47303079166130",
    effect: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Active Serum",
    productVariantId: "47300731568306",
    effect:"Hair Active Serum prevents hair thinning for fuller, healthier hair.",
    ingredientName: "3% Redensyl | 2% capixyl",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Redensyl.webp?v=1770627288 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Dimethicone.webp?v=1770616417",
    ingredientContent: "Activates hair follicles to support faster, denser hair regrowth. | Helps reduce hair fall and supports thicker, stronger hair regrowth.",
  },
  {
    product: "Hair Ras 01",
    productVariantId: "47302757875890",
    effect:"Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "Improves hair strength and supports natural hair growth. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Ras 02",
    productVariantId: "47301161091250",
    effect:"Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Bhringraj | Guduchi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_19.webp?v=1770627488",
    ingredientContent: "Nourishes the scalp and supports stronger, longer hair growth. | Reduces inflammation and supports scalp and hair follicle health.",
  },
  {
    product: "Hair Ras 05",
    productVariantId: "46464896630962",
    effect:"Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Amalki | Iron Bhasma",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Iron_Bhasma.webp?v=1770627628",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Helps correct iron deficiency, supporting healthy hair growth from within.",
  },
  {
    product: "Hair Ras 06",
    productVariantId: "47301139169458",
    effect:"Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Shatavari | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair. | Reduces stress hormones and supports scalp nourishment, helping control stress-related hair fall.",
  },
  {
    product: "Hair Ras 09",
    productVariantId: "46464745308338",
    effect:"Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Ashwagandha | Amalki",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Boosts collagen synthesis and antioxidant protection, strengthening hair follicles at the root.",
  }
];

function displayUniqueIngredients(responseProducts, containerId) {
  const uniqueIngredients = new Map();
  
  responseProducts.forEach(item => {
    const matched = popOneLinerData.find(p => p.productVariantId === String(item.product_id));
    
    if (matched && matched.ingredientName) {
      const names = matched.ingredientName.split('|').map(s => s.trim());
      const images = matched.ingredientImage.split('|').map(s => s.trim());
      const contents = matched.ingredientContent.split('|').map(s => s.trim());
      
      names.forEach((name, i) => {
        if (name && !uniqueIngredients.has(name)) {
          uniqueIngredients.set(name, {
            name,
            image: images[i] || '',
            content: contents[i] || ''
          });
        }
      });
    }
  });
  
  const ingredientsArray = Array.from(uniqueIngredients.values());
  
  let codeHtml = `
    <section class="ingredient-carousel-section">
      <div class="ingredient-carousel-mobile">
        <div class="ingredient-buttons-wrapper">
          <div class="ingredient-buttons">
  `;
  
  ingredientsArray.forEach((ing, i) => {
    codeHtml += `
      <button class="ing-btn ${i === 2 ? 'ing-active' : ''}" data-index="${i}">
        <div class="ing-btn-inner ${i === 2 ? 'ing-active-inner' : ''}">
          <img src="${ing.image}" alt="${ing.name}" width="64" height="64" />
        </div>
      </button>
    `;
  });
  
  codeHtml += `
          </div>
        </div>
        <div class="ingredient-info">
          <h3 class="ingredient-info-title">${ingredientsArray[2]?.name || ''}</h3>
          <p class="ingredient-info-desc">${ingredientsArray[2]?.content || ''}</p>
        </div>
        <div class="ingredient-nav-arrows">
          <button class="ing-arrow ing-arrow-prev" aria-label="Previous ingredient">
            <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <button class="ing-arrow ing-arrow-next" aria-label="Next ingredient">
            <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
        <div class="ingredient-dots">
  `;
  
  ingredientsArray.forEach((_, i) => {
    codeHtml += `<button class="ing-dot ${i === 2 ? 'ing-dot-active' : ''}" data-index="${i}"></button>`;
  });
  
  codeHtml += `
        </div>
      </div>
    </section>
  `;
  
  let ingredientContentBlock = document.querySelector(containerId);
  ingredientContentBlock.insertAdjacentHTML('beforeend', codeHtml);
  
  initIngredientCarousel(ingredientsArray);
}

function initIngredientCarousel(slides) {
  const btns      = [...document.querySelectorAll('.ing-btn')];
  const dots      = [...document.querySelectorAll('.ing-dot')];
  const infoTitle = document.querySelector('.ingredient-info-title');
  const infoDesc  = document.querySelector('.ingredient-info-desc');
  const prevBtn   = document.querySelector('.ing-arrow-prev');
  const nextBtn   = document.querySelector('.ing-arrow-next');

  let active = Math.floor(slides.length / 2);

  function render() {
    const isMobile = window.innerWidth <= 767;
    const positions = isMobile
      ? [-180, -105, 0, 105, 180]
      : [-195, -115, 0, 115, 195];
    const scales = [0.6, 0.8, 1.2, 0.8, 0.6];

    btns.forEach((btn, i) => {
      let diff = (i - active + slides.length) % slides.length;
      if (diff > slides.length / 2) diff -= slides.length;

      if (diff < -2 || diff > 2) {
        btn.style.transform     = `translate(-50%, -10%) translateX(0px) scale(0.6)`;
        btn.style.opacity       = '0';
        btn.style.pointerEvents = 'none';
        btn.style.visibility    = 'hidden';
        btn.classList.remove('ing-active');
        return;
      }

      const idx   = diff + 2;
      const tx    = positions[idx];
      const scale = scales[idx];

      btn.style.transform     = `translate(-50%, -10%) translateX(${tx}px) scale(${scale})`;
      btn.style.opacity       = diff === 0 ? 1 : 0.9;
      btn.style.pointerEvents = 'auto';
      btn.style.visibility    = 'visible';
      btn.classList.toggle('ing-active', diff === 0);
    });

    dots.forEach((d, i) => d.classList.toggle('ing-dot-active', i === active));
    infoTitle.textContent = slides[active].name;
    infoDesc.textContent  = slides[active].content;
  }

  function goNext() {
    active = (active + 1) % slides.length;
    render();
  }

  function goPrev() {
    active = (active - 1 + slides.length) % slides.length;
    render();
  }

  // Desktop arrow clicks
  if (prevBtn) prevBtn.addEventListener('click', goPrev);
  if (nextBtn) nextBtn.addEventListener('click', goNext);
  function attachSwipeListener(el) {
    let startX = 0;
    let startY = 0;
    let endX   = 0;
    let directionLocked = null;
    const swipeThreshold = 50;

    el.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      endX   = startX;
      directionLocked = null; 
    }, { passive: true }); 

    el.addEventListener('touchmove', (e) => {
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      endX = e.touches[0].clientX;
      if (!directionLocked) {
        if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
          directionLocked = Math.abs(dx) >= Math.abs(dy) ? 'horizontal' : 'vertical';
        }
      }

      if (directionLocked === 'horizontal') {
        e.preventDefault();
      }
    }, { passive: false }); 

    el.addEventListener('touchend', () => {
      const delta = endX - startX;
      if (directionLocked === 'horizontal' && Math.abs(delta) > swipeThreshold) {
        delta < 0 ? goNext() : goPrev();
      }
      startX = 0;
      startY = 0;
      endX   = 0;
      directionLocked = null;
    }, { passive: true });
  }

  const rcInfo    = document.querySelector('.ingredient-info');
  const rcButtons = document.querySelector('.ingredient-buttons');
  if (rcInfo)    attachSwipeListener(rcInfo);
  if (rcButtons) attachSwipeListener(rcButtons);

  btns.forEach(btn => btn.onclick = () => { active = Number(btn.dataset.index); render(); });
  dots.forEach(dot => dot.onclick = () => { active = Number(dot.dataset.index); render(); });
  render();
}

function applyOneMonthDiscount(response) {
  const discountsData = response?.discounts;
  if (!discountsData) return;

  if (!discountsData.discountValidityByPlan?._1Month) return;
  const discountObj = discountsData.discount?.[0];
  if (!discountObj) return;

  const { code, value, validCartValue } = discountObj;
  if (!code || !value || !validCartValue) return;

  const cartTotal = Math.round(response.cart_price);
  if (cartTotal < validCartValue) return;
  
  let discountAmount = 0;

  if (discountObj.type === 'percentage') {
    discountAmount = Math.round((cartTotal * value) / 100);
  } else {
    // default = flat value
    discountAmount = value;
  }

  const discountedTotal = Math.max(cartTotal - discountAmount, 0);

  // const strikeoutPriceAfterDiscount = discountedTotal + 699;
  const discountStrikeElement = document.querySelector('.strike-cart-total-price').innerHTML;
  const originalStrikePrice = discountStrikeElement.split(' ');
  console.log(originalStrikePrice[1])
  const updatedStrikePrice = originalStrikePrice[1] - value;

  // return parseInt(el.textContent.replace(/[^\d]/g, ''), 10) || 0;
  // UI price updates
  document.querySelectorAll('.strike-cart-total-price').forEach(el => {
    el.innerHTML = `₹ ${updatedStrikePrice}`;
  });

  document.querySelectorAll('.total-price').forEach(el => {
    el.innerHTML = `₹ ${discountedTotal}`;
  });
  // Show referral applied UI
  document.querySelectorAll('.refferal-discount-applied').forEach(el => {
    el.classList.remove('d-none');
  });

  // ✅ ONLY store the code
  window.appliedReferralCode = code;
}

function isExternalProduct(productId) {
  const data = ALL_PRODUCTS.find(item => item.variant_id === String(productId));
  if (!data) {
    console.warn('Product not in ALL_PRODUCTS:', productId);
    return false;
  }
  return data.external === true;
}

// ─── PULL INGREDIENTS FOR A PRODUCT FROM popOneLinerData ─────────────────────
function getIngredientsForProduct(productId) {
  const data = ALL_PRODUCTS.find(item => item.variant_id === String(productId));
  return data?.ingredients || [];
}

// ─── SHOW/HIDE A COMBO SECTION WRAPPER ───────────────────────────────────────
function toggleComboSection(selector, shouldShow) {
  const el = document.querySelector(selector);
  if (!el) return;
  el.style.display = shouldShow ? '' : 'none';
}

// ─── UPDATE "YOU SAVED" AMOUNT (strike − total) ──────────────────────────────
function updateSavedAmount() {
  const strikeEl = document.querySelector('.strike-cart-total-price');
  const totalEl  = document.querySelector('.total-price');
  const savedEl  = document.querySelector('.price-saved-amount');
  if (!strikeEl || !totalEl || !savedEl) return;

  const strike = parseInt(strikeEl.textContent.replace(/[^\d]/g, ''), 10) || 0;
  const total  = parseInt(totalEl.textContent.replace(/[^\d]/g, ''),  10) || 0;
  const saved  = Math.max(strike - total, 0);
  savedEl.textContent = `₹${saved.toLocaleString('en-IN')}`;
}

// ─── NEW PRODUCT CARD BUILDER ────────────────────────────────────────────────
// Outputs the new .product-card markup but keeps `.product-remove-btn` with the
// old data-* attributes so the existing remove-popup flow works unchanged.
function buildKitCardHTML(each, matchingExtraData) {
  const productId     = String(each.product_id);
  const FREE_PRODUCT_IDS = ["45277154377906", "47084348309682"];
  const isFreeProduct   = FREE_PRODUCT_IDS.includes(productId);

  const ingredients = getIngredientsForProduct(productId);
  const ingredientImgs = ingredients.slice(0, 2).map(i =>
    `<img src="${i.image}" alt="${i.name}" title="${i.name}" />`
  ).join('');
  const ingredientNames = ingredients.slice(0, 2).map(i => `
    <p class="ingredient-name">${i.name}</p>
    <svg xmlns="http://www.w3.org/2000/svg" class="ingredient-dot" width="4" height="4" viewBox="0 0 4 4" fill="none">
      <path d="M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2Z" fill="#787878"/>
    </svg>
  `).join('');

  const price = each.price ? `₹${Math.floor(each.price)}` : '';

  const arrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
    <path d="M0.75 8.75L4.75 4.75L0.75 0.75" stroke="#5C5C5C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
  const trashSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
    <path d="M0.599976 3.26664H12.6M11.2666 3.26664V12.6C11.2666 13.2666 10.6 13.9333 9.93331 13.9333H3.26664C2.59998 13.9333 1.93331 13.2666 1.93331 12.6V3.26664M3.93331 3.26664V1.93331C3.93331 1.26664 4.59998 0.599976 5.26664 0.599976H7.93331C8.59998 0.599976 9.26664 1.26664 9.26664 1.93331V3.26664M5.26664 6.59998V10.6M7.93331 6.59998V10.6"
      stroke="#999999" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  const dosageTag     = matchingExtraData?.howToUseData?.dosage_tag || '';
  const usageOneLiner = matchingExtraData?.howToUseData?.usage_one_liner || '';
  
  return `
    <div class="product-card ${isFreeProduct ? 'free-product-container' : ''}" data-id="${each.product_id}">
      <div class="product-left">
        <img src="${each.image_url.singleImage}" alt="${each.name}" onerror="this.style.display='none'" />
      </div>
      <div class="product-center">
        <div class="product-title-price-flex ${isFreeProduct ? 'free-product-tag' : ''}">
          <h4 class="product-title">${each.name}</h4>
          ${isFreeProduct ? `<div class="free-alignment">` :``}
          <p class="product-price">${isFreeProduct ? `<span><del>₹199</del></span>` : price}</p>
          ${isFreeProduct ? `
            <span class="custom-diet-freetag">FREE</span>
            <button class="product-arrow-btn" type="button">${arrowSVG}</button>
          ` : ''}
          </div>
        ${isFreeProduct ? `</div>` :``}
        <p class="product-effect">${each.oneLiner || ''}</p>
        ${ingredients.length ? `
          <div class="product-ingredients">
            <div class="product-ingredients-image">${ingredientImgs}</div>
            <div class="product-ingredients-name">${ingredientNames}</div>
          </div>
        ` : ''}
      </div>
      ${isFreeProduct ? '' : `
        <div class="product-right">
          <div class="product-actions">
            <button class="product-arrow-btn" type="button">${arrowSVG}</button>
            <button class="product-remove-btn" type="button"
                    data-variant-id="${each.product_id}"
                    data-product-name="${each.name}"
                    data-product-image="${each.image_url.singleImage}">
              ${trashSVG}
            </button>
          </div>
        </div>
      `}
      ${dosageTag && usageOneLiner ? `
        <div class="dosage-details--container">
          <p>${dosageTag}</p>
          <p>${usageOneLiner}</p>
        </div>
      ` : ''}
    </div>
  `;
}

function getCurrentKitVariantIds() {
  return [...document.querySelectorAll(
    '#internal-products .kit-card-container, #external-products .kit-card-container'
  )].map(card => card.dataset.productId);
}

function productComboKit(response) {
  const productData = response.product_Ids;
  document.querySelector('.result-product-kit-wrapper')?.classList.add('d-none');

  const internalContainer = document.getElementById('internal-products');
  const externalContainer = document.getElementById('external-products');
  if (!internalContainer || !externalContainer) return;

  internalContainer.innerHTML = '';
  externalContainer.innerHTML = '';

  const removedContainer = document.getElementById('removed-products');
  if (removedContainer) removedContainer.innerHTML = '';
  toggleRemovedSection();
  toggleComboSection('.removed-products-container', false);

  productData.forEach((each) => {
    const matchingExtraData = response.extraDataForProducts?.find(
      (extra) => extra.productId === each.product_id
    );

    const productDiv = document.createElement('div');
    productDiv.classList.add('kit-card-container');
    productDiv.dataset.productId   = each.product_id;
    productDiv.dataset.productName = each.name;
    productDiv.innerHTML = buildKitCardHTML(each, matchingExtraData);

    if (isExternalProduct(each.product_id)) {
      externalContainer.appendChild(productDiv);
    } else {
      internalContainer.appendChild(productDiv);
    }

    if (getCookie("GuestForm_id")) {
      variantsIDs.push({ id: each.product_id, quantity: 1, properties: { '_result_id': id } });
    } else {
      variantsIDs.push({ id: each.product_id, quantity: 1 });
    }
  });

  // Hide empty internal/external sections
  toggleComboSection('.internal-products-container', internalContainer.children.length > 0);
  toggleComboSection('.external-products-container', externalContainer.children.length > 0);

  // ── REMOVE FLOW (uses OLD popup) ──────────────────────────────────────────
  const removedProducts = [];
  let selectedVariantId = null;
  let selectedProductElement = null;

  // Open popup on remove-button click
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-remove-btn');
    if (!btn) return;
    selectedVariantId = btn.getAttribute('data-variant-id');
    selectedProductElement = document.querySelector(
      `.kit-card-container[data-product-id="${selectedVariantId}"]`
    );

    const productName  = btn.getAttribute('data-product-name');
    const productImage = btn.getAttribute('data-product-image');
    updateRemovePopupContentByProduct(productName, productImage, selectedVariantId);

    fireEvent("delete_product_clicked", caseId, selectedVariantId, productName);

    const removeBtn = document.querySelector('#remove-confirmation-popup .remove-popup-remove-btn');
    if (removeBtn) {
      removeBtn.disabled  = false;
      removeBtn.innerHTML = 'Remove';
    }

    document.getElementById('remove-confirmation-popup')?.classList.add('popup-visible');
    document.body.style.overflow = 'hidden';
  });

  // Confirm Remove
  document.querySelector('.remove-popup-remove-btn').addEventListener('click', function () {
    if (!selectedVariantId) return;

    // Snapshot before we null these out
    const variantId = selectedVariantId;
    const productEl = selectedProductElement;
    selectedVariantId = null;
    selectedProductElement = null;

    document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');
    document.body.style.overflow = '';

    if (productEl) {
      productEl.classList.add('fade-out');
      setTimeout(() => {
        productEl.remove();
        toggleComboSection('.internal-products-container',
          document.querySelectorAll('#internal-products .kit-card-container').length > 0);
        toggleComboSection('.external-products-container',
          document.querySelectorAll('#external-products .kit-card-container').length > 0);
      }, 150);
    }

    if (!removedProducts.includes(variantId)) {
      removedProducts.push(variantId);
      const removedProduct = productData.find(p => p.product_id === variantId);

      if (removedProduct) {
        renderRemovedProductCard(removedProduct);
        const removedFromKit = bundleMap.bundle1.find(p => p.variantId === variantId);
        if (removedFromKit) restoreProductToOptionalList(removedFromKit, response);
      } else {
        // Addon-in-kit being removed → goes back to addons shelf, not "removed"
        const optionalProduct = bundleMap.bundle1.find(p => p.variantId === variantId);
        if (optionalProduct) restoreProductToOptionalList(optionalProduct, response);
      }
    }

    toggleRemovedSection();

    // const wrapper = document.querySelector('.combo-section.removed-products-container');
    // if (wrapper) {
    //   wrapper.classList.remove('d-none');
    //   wrapper.style.removeProperty('display');
    // }

    toggleComboSection('.internal-products-container',
      document.querySelectorAll('#internal-products .kit-card-container').length > 0);
    toggleComboSection('.external-products-container',
      document.querySelectorAll('#external-products .kit-card-container').length > 0);

    updateStrikePriceAfterRemoval(response, variantId);
    updateSavedAmount();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: 0 } })
    })
    .then(res => res.json())
    .then(cart => {
      // refreshCartUI();
      const FREE_PRODUCT_IDS = ["45277154377906", "47084348309682"];
      const nonFreeItemsLeft = cart.items.filter(
        item => !FREE_PRODUCT_IDS.includes(String(item.variant_id))
      ).length;

      if (nonFreeItemsLeft === 0) {
        showCartAlmostEmptyPopup();
        document.querySelectorAll(
          '#internal-products .kit-card-container, #external-products .kit-card-container'
        ).forEach(card => card.remove());
      }
    })
    .catch(err => console.error('Error during removal:', err));
  });

  document.querySelector('.remove-popup-keep-btn').addEventListener('click', function () {
    selectedProductElement = null;
    selectedVariantId      = null;
    document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');
    document.body.style.overflow = '';
  });

  // Add-back from removed list
  document.addEventListener('click', async function (e) {
    if (!e.target.classList.contains('add-removed-to-cart-btn')) return;

    const variantId = e.target.getAttribute('data-variant-id');
    e.target.disabled = true;
    e.target.classList.add('disabled');

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      localStorage.setItem('User_location', 'cart');

      const idx = removedProducts.indexOf(variantId);
      if (idx > -1) removedProducts.splice(idx, 1);

      const restoredProduct = productData.find(p => p.product_id === variantId);
      if (!restoredProduct) return;

      fireEvent("add_back", caseId, restoredProduct.product_id, restoredProduct.name);

      const matchingExtraData = response.extraDataForProducts?.find(
        (extra) => extra.productId === restoredProduct.product_id
      );

      const productDiv = document.createElement('div');
      productDiv.classList.add('kit-card-container', 'fade-in');
      productDiv.dataset.productId   = restoredProduct.product_id;
      productDiv.dataset.productName = restoredProduct.name;
      productDiv.innerHTML = buildKitCardHTML(restoredProduct, matchingExtraData);

      const targetContainer = isExternalProduct(restoredProduct.product_id)
        ? document.getElementById('external-products')
        : document.getElementById('internal-products');

      if (targetContainer) {
        setTimeout(() => {
          targetContainer.appendChild(productDiv);
      }, 50);
      }

      e.target.closest('.removed-product')?.remove();

      toggleRemovedSection();
      // Make sure the target section is visible
      const sectionSelector = isExternalProduct(restoredProduct.product_id)
        ? '.external-products-container'
        : '.internal-products-container';
      toggleComboSection(sectionSelector, true);

      updateStrikePriceAfterAddition(response, variantId, 'kit');
      updateSavedAmount();
    } catch (err) {
      console.error('Error:', err);
    }
  });

  if (trayaProcessingAnimation) trayaProcessingAnimation.style.display = 'none';
  document.body.style.overflow = 'unset';
  updateSavedAmount();
}

// Empty-cart state — rendered inside the old popup box
function showCartAlmostEmptyPopup() {
  // Fetch cart state first to avoid calling clear.js on an already-empty cart.
  // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
  fetch('/cart.js').then(r => r.json()).then(cartState => {
    if ((cartState.item_count || 0) > 0) fetch('/cart/clear.js');
  });

  const popup    = document.getElementById('remove-confirmation-popup');
  const popupBox = popup?.querySelector('.remove-popup-box');
  if (!popup || !popupBox) return;

  popupBox.innerHTML = `
    <div class="remove-popup-flex">
      <h2 class="empty-cart-title">Your Cart is Empty</h2>
      <p class="empty-cart-msg">You have removed all products in your kit!</p>
    </div>
    <button class="go-back-btn" style="margin-top: 20px;" onclick="window.location.href = window.location.href;">
      Go Back To Original Cart
    </button>
  `;
  popup.style.display = 'flex';
  popup.classList.add('popup-visible');
  document.body.style.overflow = 'hidden';
}

function fireEvent(eventName, caseID, productId, productName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "productId": productId,
          "productName": productName,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function productFireEvent(eventName, caseID, productName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "productName": productName,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

function fireClinicEvent(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

// WhatsApp Tooltip Animation Function
function initWhatsAppTooltipAnimation() {
  const tooltip = document.querySelector('.whats-app-tooltip');
  if (!tooltip) return;
  function showAndHideTooltip() {
    setTimeout(() => {
      tooltip.classList.add('show');
      tooltip.classList.remove('fade-out');
      setTimeout(() => {
        tooltip.classList.add('fade-out');
        tooltip.classList.remove('show');
      }, 5000);

    }, 10000);
  }
  showAndHideTooltip();
  setInterval(showAndHideTooltip, 15000);
}

function adjustDietPlanMarkup(variantId, action) {
  if (isExternalProduct(variantId)) return;

  const before = window.internalKitCount || 0;
  const after  = action === 'add' ? before + 1 : Math.max(before - 1, 0);
  window.internalKitCount = after;

  let delta = 0;
  if (before === 0 && after > 0)      delta = 200;   
  else if (before > 0 && after === 0) delta = -200; 
  if (!delta) return;

  document.querySelectorAll('.strike-cart-total-price').forEach(el => {
    const current = parseInt(el.textContent.replace(/[^\d]/g, ''), 10) || 0;
    el.textContent = `₹${(current + delta).toLocaleString('en-IN')}`;
  });
}

function updateStrikePriceAfterRemoval(response, removedVariantId) {
  const strikeEls = document.querySelectorAll('.strike-cart-total-price');
  const totalEls = document.querySelectorAll('.total-price');

  let currentStrikePrice = parseInt(
    strikeEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let currentTotalPrice = parseInt(
    totalEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let removedProduct =
    response.product_Ids.find(p => String(p.product_id) === String(removedVariantId)) ||
    bundleMap?.bundle1?.find(p => String(p.variantId) === String(removedVariantId));

  if (!removedProduct) return;

  const removedOriginalPrice = Number(
    removedProduct.price || removedProduct.price || 0
  );

  const removedSellingPrice = Number(
    removedProduct.price || 0
  );

  let rawStrikePrice = currentStrikePrice - removedOriginalPrice;
  let rawTotalPrice = currentTotalPrice - removedSellingPrice;

  let discountAmount = 0;
  if (
    window.appliedDiscountMeta &&
    rawTotalPrice >= window.appliedDiscountMeta.minCart
  ) {
    if (window.appliedDiscountMeta.type === 'percentage') {
      discountAmount = Math.round(
        (rawTotalPrice * window.appliedDiscountMeta.value) / 100
      );
    } else {
      discountAmount = window.appliedDiscountMeta.value;
    }
  }

  const updatedTotalPrice = Math.max(rawTotalPrice - discountAmount, 0);

  strikeEls.forEach(el => {
    el.textContent = `₹${Math.round(rawStrikePrice).toLocaleString('en-IN')}`;
  });

  totalEls.forEach(el => {
    el.textContent = `₹${Math.round(updatedTotalPrice).toLocaleString('en-IN')}`;
  });
  adjustDietPlanMarkup(removedVariantId, 'remove');
}

function updateStrikePriceAfterAddition(response, variantId, type) {
  const strikeEls = document.querySelectorAll('.strike-cart-total-price');
  const totalEls = document.querySelectorAll('.total-price');

  let currentStrikePrice = parseInt(
    strikeEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let currentTotalPrice = parseInt(
    totalEls[0]?.textContent.replace(/[^\d]/g, '')
  ) || 0;

  let addedProduct = null;

  if (type === "kit") {
    addedProduct = response.product_Ids.find(
      p => String(p.product_id) === String(variantId)
    );
  }

  if (type === "optional") {
    addedProduct = bundleMap?.bundle1?.find(
      p => String(p.variantId) === String(variantId)
    );
  }

  if (!addedProduct) return;

  const addedOriginalPrice = Number(
    addedProduct.price || addedProduct.price || 0
  );

  const addedSellingPrice = Number(
    addedProduct.price || 0
  );

  let rawStrikePrice = currentStrikePrice + addedOriginalPrice;
  let rawTotalPrice = currentTotalPrice + addedSellingPrice;

  let discountAmount = 0;
  if (
    window.appliedDiscountMeta &&
    rawTotalPrice >= window.appliedDiscountMeta.minCart
  ) {
    if (window.appliedDiscountMeta.type === 'percentage') {
      discountAmount = Math.round(
        (rawTotalPrice * window.appliedDiscountMeta.value) / 100
      );
    } else {
      discountAmount = window.appliedDiscountMeta.value;
    }
  }

  const updatedTotalPrice = Math.max(rawTotalPrice - discountAmount, 0);

  strikeEls.forEach(el => {
    el.textContent = `₹${Math.round(rawStrikePrice).toLocaleString('en-IN')}`;
  });

  totalEls.forEach(el => {
    el.textContent = `₹${Math.round(updatedTotalPrice).toLocaleString('en-IN')}`;
  });
  adjustDietPlanMarkup(variantId, 'add');   
}
function removeCartItemByKey(lineItemKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  })
  .then(res => res.json())
  .then(cart => {
    console.log(cart)
  })
  .catch(err => console.error('Error removing item:', err));
}

function renderRemovedProductCard(product) {
  const container = document.getElementById('removed-products');
  if (!container) return;

  // Pull the one-liner / effect from ALL_PRODUCTS (same source addons use)
  const data       = ALL_PRODUCTS.find(item => item.variant_id === String(product.product_id));
  const effectText = data?.effect || product.oneLiner || '';

  const isFree = product.product_id === "45277154377906";
  const price  = isFree
    ? '₹0'
    : (product.price ? `₹${Math.round(product.price)}` : '');

  fireEvent("delete_product", caseId, product.product_id, product.name);

  // toggleComboSection('.removed-products-container', true);

  const productDiv = document.createElement('div');
  // 👇 Both classes: `addon-card` for the visual styling, `removed-product` so
  //    the existing closest('.removed-product') lookup in the add-back handler still works.
  productDiv.className = 'addon-card removed-product';
  productDiv.dataset.productId = product.product_id;
  productDiv.innerHTML = `
    <div class="addon-left">
      <img src="${product.image_url.singleImage}" alt="${product.name}" width="100" height="100" loading="lazy" />
    </div>
    <div class="addon-center">
      <p class="addon-title">${product.name}</p>
      <p class="addons-price">${price}</p>
    </div>
    <div class="addon-right">
      <button class="add-removed-to-cart-btn" data-variant-id="${product.product_id}">
        Add to Cart
      </button>
    </div>
  `;
  container.appendChild(productDiv);
}

function toggleRemovedSection() {
  const wrapper = document.querySelector('.combo-section.removed-products-container')
               || document.querySelector('.removed-products-container');
  if (!wrapper) return;
  const hasItems = document.querySelectorAll('#removed-products .removed-product').length > 0;
  if (hasItems) {
    wrapper.classList.remove('d-none');
    wrapper.style.removeProperty('display');
  } else {
    wrapper.classList.add('d-none');
    wrapper.style.display = 'none';  
  }
}

const bundleMap = {
  bundle1: [
    {
      "variantId": "44650256728242",
      "name": "Defence conditioner",
      "image_url": "https://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/defenceConditioner50mg1.png",
      "one_liner": "Conditions and Smoothens Hair Texture",
      "tag": "Softens Hair",
      "price": "320.00"
    },
    {
      "variantId": "47301151064242",
      "name": "Defence Shampoo",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_1_86e4caf1-109f-4f35-a88c-3bc4b35e869c.webp?v=1763373344",
      "one_liner": "Hydrates Deeply and Reduces Dryness",
      "tag": "Cleans scalp",
      "price": "267.00",
      "originalPrice": "300"
    },
    {
      "variantId": "46528923304114",
      "name": "Anti Dandruff Lotion",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Solution.webp?v=1765353677",
      "one_liner": "Night Lotion fights dandruff to help reduce hair fall.",
      "tag": "Clears Dandruff",
      "price": "355.00",
      "originalPrice": "399"
    },
    {
      "variantId": "47303097352370",
      "name": "hair vitamin for her",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property.webp?v=1766144058",
      "one_liner": "Supplements to meet Hair's Nutrition needs.",
      "tag": "Nourishes Hair",
      "price": "463.00",
      "originalPrice": "520"
    },
    {
      "variantId": "47301148803250",
      "name": "Shine serum",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/shine_leave_in_serum.webp?v=1771394293",
      "one_liner": "Shine Serum enhances hair texture for a vibrant, healthy look.",
      "tag": "Adds Shine",
      "price": "599.00"
    },
    {
      "variantId": "47329496826034",
      "name": "Anti-Dandruff Shampoo",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Shampoo2.webp?v=1765353725",
      "one_liner": "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall.",
      "tag": "Clears dandruff",
      "price": "281.00",
      "originalPrice": "300"
    }
  ]
};
function optionalAddOnProducts(response) {
  const firstChar = String(caseId || '').charAt(0).toLowerCase();
  const addonsContainer = document.getElementById('addons-section');
  if (!addonsContainer) return;

  addonsContainer.innerHTML = '';

  const optionalProductBundle = bundleMap.bundle1;
  const responseProductData   = response.product_Ids;
  const excludedIds           = new Set(["44650256728242"]);

  const existingVariantIds = new Set(
    responseProductData
      .map(p => String(p.product_id))
      .filter(productId => !excludedIds.has(productId))
  );

  if (!optionalProductBundle) return;

  toggleComboSection('.addons-section-container', true);

  optionalProductBundle.forEach((optionalProduct) => {
    if (existingVariantIds.has(optionalProduct.variantId)) return;

    const price = optionalProduct.price ? `₹${Math.floor(optionalProduct.price)}` : '';

    const productDiv = document.createElement('div');
    productDiv.classList.add('addon-card');
    productDiv.dataset.productId   = optionalProduct.variantId;
    productDiv.dataset.productName = optionalProduct.name;
    productDiv.innerHTML = `
      <div class="addon-left">
        <img src="${optionalProduct.image_url}" alt="${optionalProduct.name}" width="100" height="100" loading="lazy" />
      </div>
      <div class="addon-center">
        <p class="addon-title">${optionalProduct.name}</p>
        <p class="addon-product-effect">${optionalProduct.tag || ''}</p>
        <p class="addons-price">${price}</p>
      </div>
      <div class="addon-right">
        <button class="optional-add-btn"
                data-variant-id="${optionalProduct.variantId}"
                data-product-name="${optionalProduct.name}"
                data-product-image="${optionalProduct.image_url}">
          Add to Cart
        </button>
      </div>
    `;
    addonsContainer.appendChild(productDiv);
  });

  if (addonsContainer.children.length === 0) {
    toggleComboSection('.addons-section-container', false);
  }

  // ADD ADDON click
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.optional-add-btn');
    if (!addBtn) return;

    const variantId   = addBtn.getAttribute('data-variant-id');
    const productName = addBtn.getAttribute('data-product-name');

    fireEvent("addon_add_to_cart_click", caseId, variantId, productName);

    addBtn.disabled = true;
    addBtn.classList.add('disabled');

    insertAddOnProductIntoKit(optionalProductBundle, variantId, existingVariantIds);
    updateStrikePriceAfterAddition(response, variantId, 'optional');
    updateSavedAmount();

    addBtn.closest('.addon-card')?.remove();

    if (addonsContainer.children.length === 0) {
      toggleComboSection('.addons-section-container', false);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: {} })
    })
    .then(() => refreshCartUI())
    .catch(err => console.error('Error adding to cart:', err));
  });
}

function insertAddOnProductIntoKit(optionalProducts, variantId, existingVariantIds) {
  if (existingVariantIds.has(String(variantId))) return;

  const product = optionalProducts.find(p => p.variantId === variantId);
  if (!product) return;

  // Bundle shape → kit-card shape
  const adapted = {
    product_id: product.variantId,
    name:       product.name,
    image_url:  { singleImage: product.image_url },
    oneLiner:   product.one_liner,
    price:      product.price
  };

  const targetContainer = isExternalProduct(product.variantId)
    ? document.getElementById('external-products')
    : document.getElementById('internal-products');

  if (!targetContainer) return;

  const productDiv = document.createElement('div');
  productDiv.classList.add('kit-card-container', 'fade-in');
  productDiv.dataset.productId   = adapted.product_id;
  productDiv.dataset.productName = adapted.name;
  productDiv.innerHTML = buildKitCardHTML(adapted, null);

  targetContainer.appendChild(productDiv);

  const sectionSelector = isExternalProduct(product.variantId)
    ? '.external-products-container'
    : '.internal-products-container';
  toggleComboSection(sectionSelector, true);
}

function restoreProductToOptionalList(product, response) {
  const responseProductData = response.product_Ids;
  const existingVariantIds  = new Set(responseProductData.map(p => String(p.product_id)));

  const container = document.getElementById('addons-section');
  if (!container) return;
  if (existingVariantIds.has(String(product.variantId))) return;

  const price = product.price ? `₹${Math.floor(product.price)}` : '';

  const productDiv = document.createElement('div');
  productDiv.classList.add('addon-card');
  productDiv.dataset.productId = product.variantId;
  productDiv.innerHTML = `
    <div class="addon-left">
      <img src="${product.image_url}" alt="${product.name}" width="100" height="100" loading="lazy" />
    </div>
    <div class="addon-center">
      <p class="addon-title">${product.name}</p>
      <p class="addon-product-effect">${product.tag || ''}</p>
      <p class="addons-price">${price}</p>
    </div>
    <div class="addon-right">
      <button class="optional-add-btn"
              data-variant-id="${product.variantId}"
              data-product-name="${product.name}"
              data-product-image="${product.image_url}">
        Add to Cart
      </button>
    </div>
  `;
  container.appendChild(productDiv);

  toggleComboSection('.addons-section-container', true);
}

function updateRemovePopupContentByProduct(productName, productImage, selectedVariantId) {
  const matched = popOneLinerData.find(item => item.productVariantId === selectedVariantId);

  const titleElement = document.querySelector('.remove-popup-title');
  const imageElement = document.querySelector('.remove-popup-image');

  if (matched) {
    if (titleElement) titleElement.textContent = matched.effect;
    if (imageElement) imageElement.src = productImage || 'fallback.jpg';
  } else {
    if (titleElement) titleElement.textContent = "Are you sure you want to remove this item?";
    if (imageElement && productImage) imageElement.src = productImage;
  }
}

function languageSelection() {
  const languageIcon = document.getElementById("language-icon-faq");
  const languageDropdown = document.getElementById("language-dropdown");
  const languageOptions = document.querySelectorAll(".language-option-faq");
  const faqHinglishElements = document.querySelectorAll(".faq-question-answer.hinglish-faq");
  const faqEnglishElements = document.querySelectorAll(".faq-question-answer.english-faq");
  const wrapper = document.querySelector(".faq-hinglish-toggle--wrapper");
  const languageArrow = document.querySelector("#language-icon-faq .language-arrow");
  const languageText = document.querySelector("#language-icon-faq .language-icon-faq"); 

  languageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    const isHidden = languageDropdown.classList.contains("hidden");

    languageDropdown.classList.toggle("hidden");
    wrapper.classList.toggle("hidden-dropdown");

    if (languageArrow) {
      languageArrow.classList.toggle("rotate", isHidden);
    }
  });

  languageOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      const selectedLang = e.target.getAttribute("hreflang");
      const languageSelected = e.target.getAttribute("lang");

      fireEvent("faq_toggle_clicked", caseId, languageSelected);

      languageOptions.forEach(opt => opt.classList.remove("active"));
      e.target.classList.add("active");
      languageText.textContent = selectedLang === "hi" ? "HI-EN" : "EN";

      if (selectedLang === "hi") {
        faqHinglishElements.forEach(el => el.classList.remove("d-none"));
        faqEnglishElements.forEach(el => el.classList.add("d-none"));
      } else {
        faqHinglishElements.forEach(el => el.classList.add("d-none"));
        faqEnglishElements.forEach(el => el.classList.remove("d-none"));
      }

      languageDropdown.classList.add("hidden");
      wrapper.classList.add("hidden-dropdown");

      if (languageArrow) {
        languageArrow.classList.remove("rotate");
      }
    });
  });
  if(languageIcon && languageDropdown){
    document.addEventListener("click", (e) => {
        if (!languageIcon.contains(e.target) && !languageDropdown.contains(e.target)) {
        if (!languageDropdown.classList.contains("hidden")) {
            languageDropdown.classList.add("hidden");
            wrapper.classList.add("hidden-dropdown");
            if (languageArrow) {
            languageArrow.classList.remove("rotate");
            }
        }
        }   
    });
  }
}

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.monthExpectations && monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    // const weeksUpdateElement = document.querySelector('.weeks-update')
    // weeksUpdateElement.innerHTML = monthsExpectation.months;
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}"  width="100px" height="100px" loading="lazy">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p class="monthe-suggestion">${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });

    if (timeline) {
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
      });
      if ($(window).width() < 768) {
        $(timeline).slick('unslick');
      }
      if (monthsExpectation.monthExpectations.length <= 4) {
        timeline.classList.add('minus-the-margin');
        $(timeline).slick('unslick');
      }
    }
  }
}
// timeline section end

// custom price 
function customPriceSection(response) {
  let cartPrice = response.cart_price;
  cartPrice = parseFloat(cartPrice).toFixed(2);
  if (cartPrice.endsWith('.00')) {
    cartPrice = parseInt(cartPrice);
  }
  
  const dynamicPriceElements = document.querySelectorAll('#dynamic-price');
  if (dynamicPriceElements.length > 0) {
    dynamicPriceElements.forEach(element => {
      element.innerHTML = cartPrice;
    });
  } else {
    console.error('Price elements not found');
  }
}
// end of custom price

// doctor recomandation section 
function sectionBlocksDisplay(response) {
  let { User_Analysis } = response;
  let stage = User_Analysis.hair_fall_stage;
  const apiSection = document.querySelector('.static-block-container');
  const staticSection = document.querySelector('.block-container');

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  if (stage == "No widening" || stage == "Starting to see widening") {
    apiSection.style.display = 'none';
    staticSection.style.display = isDesktop ? 'flex' : 'block';
  } else {
    apiSection.style.display = isDesktop ? 'flex' : 'block';
    staticSection.style.display = 'none';
  }
}
// doctor recomandation section end

// women's stories section function
function sectionWomensStories(response) {
  let { successStories } = response;
  if (successStories.stories && successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');

    // Set title and subtitle
    titleElement.textContent = 'Real Women, Real Stories';

    // Loop through each story to create image elements
    successStories.stories.forEach((storyUrl) => {        
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl}" alt="Success Story" height="auto" width="auto" loading="lazy" >
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    // Initialize the Slick carousel after appending elements
    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false, 
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}
// women's stories section function end

// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };

  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    popup.style.bottom = '0';
  } else {
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  const closeIcon = document.getElementById('close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Event delegation to handle click on product cards
const comboApp = document.getElementById('combo-app');
if (comboApp) {
  comboApp.addEventListener('click', function (event) {
    if (event.target.closest('.product-remove-btn')) return;
    if (event.target.closest('.add-removed-to-cart-btn')) return;
    if (event.target.closest('.optional-add-btn')) return;

    const card = event.target.closest('.kit-card-container');
    if (!card) return;

    const productId   = card.getAttribute('data-product-id');
    const productName = card.getAttribute('data-product-name');
    productFireEvent("web_product_card_clicked", caseId, productName);
    createProductPopup(productId);
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

function clearCart() {
  $.getJSON('/cart.js', function(cart) {
    if (cart.item_count === 0) { silentCheckout(); return; }
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        silentCheckout();
      },
      error: function(error) {
        console.error('Error on first clear:', error);
      }
    });
  });
}

function silentCheckout() {
  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
    eachBtn.classList.add('loader-added')
    eachBtn.disabled = true;
  })
  localStorage.setItem('user__gender', user_gender);
  localStorage.setItem('caseId', caseId);
  if(user__gender == 'F') {
    user_gender = 'Female';
  }
  variantsIDs.forEach(e => {
    e.properties = { 'Plan': 'Auto' };
  });

  const formData = {
    items: variantsIDs,
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      caseid: caseId,
      user__gender: user_gender,
      hair_Stage: userHairStage
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(result => {
    localStorage.setItem('User_location', 'cart');
    console.log("Silent checkout complete");    
  })
  .catch(error => {
    console.error('Silent checkout error:', error);
  })
  .finally(() => {
    setTimeout(() => {
      removeLoader();
      updateCartUtmAttributes();
    }, 800);
  });
}

function updateCartUtmAttributes() {
  const utmParams = ['utm_source', 'utm_campaign', 'utm_medium'];
  const urlParams = new URLSearchParams(window.location.search);

  // Capture URL utm_* into localStorage
  utmParams.forEach(param => {
    const val = urlParams.get(param);
    if (val) localStorage.setItem(param, val);
  });

  // Collect stored utm_* into the payload
  const attributes = {};
  utmParams.forEach(param => {
    const val = localStorage.getItem(param);
    if (val) attributes[param] = val;
  });

  if (Object.keys(attributes).length === 0) return Promise.resolve();

  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart.items || cart.items.length === 0) return; // nothing to attach to
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      })
      .then(res => res.json())
      .then(() => console.log('Cart attributes updated:', attributes));
    })
    .catch(err => console.error('Failed to update cart:', err));
}

window.addEventListener('DOMContentLoaded', function() {
  var stickyBtn = document.querySelector('[sticky__btn]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
    // stickyBtn.style.zIndex = '9999';
  }
  
  var stickyBtn = document.querySelector('[btn_sticky]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
    // stickyBtn.style.zIndex = '9999';
  }
  const stickyButton = document.querySelector('.template-page.female-result [sticky__btn]');
  const stickyButtonCuticle = document.querySelector('.template-page.female-result [btn_sticky]');
  const addToCartButton = document.getElementById('add-to-cart-result-page-frp');
  
  const addZIndex = (element) => {
    if (element) {
      element.style.zIndex = '9999';
    }
  };

  const removeZIndex = (element) => {
    if (element) {
      element.style.zIndex = '';
    }
  };

  const handleAddToCartClick = () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      if (stickyButton && stickyButton.style.zIndex === '9999') {
        removeZIndex(stickyButton);
      } else {
        addZIndex(stickyButton);
      }
    }
  };

  if (window.matchMedia("(min-width: 768px)").matches) {
    addZIndex(stickyButton);
  }

  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      handleAddToCartClick();
    });
  }
  
  window.addEventListener('resize', () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      addZIndex(stickyButton);
    } else {
      removeZIndex(stickyButton);
    }
  });
});

function initBannerPopup() {
  const bannerLink = document.querySelector('.traya-banner-link');
  bannerLink.classList.remove('d-none')
  if (!document.getElementById('bp-popup')) {
    document.body.insertAdjacentHTML('beforeend', `
      <style>
        #bp-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.55); z-index:10000; }
        #bp-popup {
          position: fixed;
          background: #fff;
          z-index: 99999;;
          overflow-y: auto;
          opacity: 0;
          transition: transform 0.35s ease, opacity 0.35s ease;
        }

        /* Desktop — centered modal */
        @media (min-width: 768px) {
          #bp-popup {
            top: 50%; left: 50%;
            width: 812px;
            max-height: 85vh;
            border-radius: 16px;
            transform: translate(-50%, -50%) scale(0.85);
          }
          #bp-popup.bp-open {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
        }

        /* Mobile — bottom sheet */
        @media (max-width: 767px) {
          #bp-popup {
            left: 0; right: 0; bottom: 0;
            max-height: 75vh;
            border-radius: 16px 16px 0 0;
            transform: translateY(100%);
          }
          #bp-popup.bp-open {
            transform: translateY(0);
            opacity: 1;
          }
        }
      </style>
      <div id="bp-overlay"></div>
      <div id="bp-popup">
        <div style="position:sticky;top:0;background:#fff;display:flex;justify-content:flex-end;padding:12px 16px;z-index:1; height: 2px;">
          <button id="bp-close" style="background:none;border:none;font-size:24px;cursor:pointer">&#x2715;</button>
        </div>
        <div id="bp-content" style="padding:0 16px 32px"></div>
      </div>
    `);
  }

  const overlay = document.getElementById('bp-overlay');
  const popup   = document.getElementById('bp-popup');
  const content = document.getElementById('bp-content');
  let cache        = null;
  let fetchPromise = null;

  function ensureSlickCSS() {
    ['slick.css', 'slick-theme.css'].forEach(function(f) {
      const href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/' + f;
      if (!document.querySelector('link[href="' + href + '"]')) {
        const link = document.createElement('link');
        link.rel  = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });
  }

  function load() {
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch('/pages/hair-growth-science?pb=0')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!document.getElementById('bp-styles')) {
          const wrap = document.createElement('div');
          wrap.id = 'bp-styles';
          doc.querySelectorAll('head style').forEach(function(s) {
            const st = document.createElement('style');
            st.textContent = s.textContent;
            wrap.appendChild(st);
          });
          document.head.appendChild(wrap);
        }
        cache = (doc.querySelector('main') || doc.body).innerHTML;
        // ✅ No render() here — scripts only run when popup is actually opened
        return cache;
      })
      .catch(function(err) { console.error('BP fetch failed:', err); fetchPromise = null; });
  }

  function render() {
    content.innerHTML = cache;
    content.querySelectorAll('script').forEach(function(old) {
      if (old.textContent.indexOf('cs-slider') > -1) return;
      const s = document.createElement('script');
      if (old.src) { s.src = old.src; s.async = false; }
      else { s.textContent = old.textContent; }
      document.body.appendChild(s);
    });
    ensureSlickCSS();
    waitAndInitCSSlider();
  }

  function waitAndInitCSSlider() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(waitAndInitCSSlider, 100);
      return;
    }
    setTimeout(function() {
      const $s = jQuery('#bp-popup .cs-slider');
      if (!$s.length) { console.warn('BP: .cs-slider not found in popup'); return; }
      if ($s.hasClass('slick-initialized')) { $s.slick('unslick'); }
      const $dots  = jQuery('#bp-popup .cs-dots');
      const $label = jQuery('#bp-popup .cs-dot-label');
      $s.slick({
        slidesToShow: 2.2, slidesToScroll: 1, centerMode: false,
        dots: false, arrows: false,
        infinite: false, autoplay: true, autoplaySpeed: 2500, speed: 600,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 2.2, centerMode: false } },
          { breakpoint: 768,  settings: { slidesToShow: 1.2, centerMode: false } }
        ]
      });
      const total = $s.slick('getSlick').slideCount;
      $dots.empty();
      for (var _d = 0; _d < total; _d++) {
        jQuery('<button type="button" class="cs-mdot" aria-label="Go to slide ' + (_d + 1) + '"></button>')
          .toggleClass('is-active', _d === 0)
          .appendTo($dots);
      }
      $dots.on('click', '.cs-mdot', function() { $s.slick('slickGoTo', jQuery(this).index()); });
      if ($label.length) $label.text('1 / ' + total);
      $s.on('afterChange', function(e, slick, i) {
        $dots.find('.cs-mdot').removeClass('is-active').eq(i).addClass('is-active');
        if ($label.length) $label.text((i + 1) + ' / ' + slick.slideCount);
      });
      console.log('BP: CS slider initialised with', total, 'slides');
    }, 200);
  }

  function open() {
    overlay.style.display        = 'block';
    popup.style.display          = 'block';
    document.body.style.overflow = 'hidden';
    popup.scrollTop              = 0;
    requestAnimationFrame(() => popup.classList.add('bp-open'));
    // ✅ Always goes through load() — resolves instantly if already cached
      // ✅ Prefetch HTML only — no script injection on page load
    chatIconClicked("hair_science_component_click", caseId);
    load().then(() => render());
  }

  function close() {
    popup.classList.remove('bp-open');
    setTimeout(function() {
      overlay.style.display = 'none';
      popup.style.display   = 'none';
    }, 350);
    document.body.style.overflow = '';
  }

  bannerLink.addEventListener('click', function(e) { e.preventDefault(); open(); });
  document.getElementById('bp-close').addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });


  load();
}

function initComparisonComponent(response) {
  const { User_Analysis, stageTransition } = response;
  if(!stageTransition?.current) return;
  const hairStage     = User_Analysis?.hair_fall_stage?.toLowerCase() || '';
  const currentCaseId = User_Analysis?.case_id || '';

  // ── DOM refs ───────────────────────────────────────────────────────────────
  const oldCreative = document.querySelector('.stageWise-img');
  const compWrapper = document.getElementById('stage-comparison-component');
  const fromImgEl   = document.getElementById('comp-from-img');
  const toImgEl     = document.getElementById('comp-to-img');
  const toLabelEl   = document.getElementById('comp-to-label');
  const descEl      = document.getElementById('comp-description');
  const tabBtns     = document.querySelectorAll('.stage-comp-tab');

  // ── Helper: show original creative, hide new component ───────────────────
  function showFallback() {
    if (oldCreative) {
      oldCreative.classList.remove('d-none');
      oldCreative.style.setProperty('display', 'flex');
    }
    if (compWrapper) compWrapper.classList.add('d-none');
  }

  // ── Gate 1: valid case ID ─────────────────────────────────────────────────
  const isValidChatCase = currentCaseId && /^[0-7]/.test(currentCaseId);
  if (!isValidChatCase) {
    showFallback();
    return;
  }

  // ── Gate 2: eligible hair stage ───────────────────────────────────────────
  const VALID_STAGES = ['hair thinning', 'side thinning'];
  if (!VALID_STAGES.includes(hairStage)) {
    showFallback();
    return;
  }

  // ── Safety: required DOM elements present? ────────────────────────────────
  if (!compWrapper || !fromImgEl || !toImgEl) return;

  // ── Override stageTransition.current & stageTransition.getYouHere ─────────
  const OVERRIDE_IMAGES = {
    'hair thinning': {
      current    : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/you-are-here-hair-thining.png?v=1774440228',
      getYouHere : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/you-will-be-here-with-traya.png?v=1774440229'
    },
    'side thinning': {
      current    : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Side_thinning_you_are_here.png?v=1774440595',
      getYouHere : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Side_thinning_with_traya.png?v=1774440595'
    }
  };

  if (OVERRIDE_IMAGES[hairStage]) {
    stageTransition.current    = OVERRIDE_IMAGES[hairStage].current;
    stageTransition.getYouHere = OVERRIDE_IMAGES[hairStage].getYouHere;
  }

  // ── Without Traya images ──────────────────────────────────────────────────
  const WITHOUT_TRAYA_IMAGES = {
    'hair thinning': 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Option_2_without_Traya.png?v=1774438594',
    'side thinning': 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Side_thinning_without_Traya_2.png?v=1774440595'
  };

  const currentImg    = stageTransition.current;
  const getYouHereImg = stageTransition.getYouHere;

  // ── Activate component ────────────────────────────────────────────────────
  const femaleSection = document.querySelector('.female-test-report-section');
  if (femaleSection) femaleSection.classList.add('stage-comp-active');

  if (oldCreative) oldCreative.style.setProperty('display', 'none', 'important');
  compWrapper.classList.remove('d-none');

  document.querySelectorAll(
    '.hair_thinning_week_text-container, .desktopDescription, .mobileDescription'
  ).forEach(el => el.style.setProperty('display', 'none', 'important'));

  // ── Descriptions ──────────────────────────────────────────────────────────
  const DESCRIPTIONS = {
    'hair thinning': {
      with   : 'Traya works internally and externally to control hairfall and get hair volume back',
      without: 'Hairfall overtime leads to hair thinning & volume reduction'
    },
    'side thinning': {
      with   : 'Traya addresses the root causes of hair fall and supports in stronger growth and fuller side volume of hair',
      without: 'Thinning at the sides may worsen over time making more scalp visible from the sides'
    }
  };

  const CONTENT = {
    with: {
      toImg  : getYouHereImg,
      toLabel: "You'll be here",
      desc   : DESCRIPTIONS[hairStage].with
    },
    without: {
      toImg  : WITHOUT_TRAYA_IMAGES[hairStage] || '',
      toLabel: "You'll be here",
      desc   : DESCRIPTIONS[hairStage].without
    }
  };

  fromImgEl.src = currentImg;

  // ── Render a tab ──────────────────────────────────────────────────────────
  function renderTab(tab, isManual = false) {
    const data = CONTENT[tab];

    toImgEl.style.opacity = '0';
    descEl.style.opacity  = '0';

    setTimeout(() => {
      toImgEl.src           = data.toImg;
      toLabelEl.textContent = data.toLabel;
      descEl.textContent    = data.desc;
      toImgEl.style.opacity = '1';
      descEl.style.opacity  = '1';
    }, 150);

    tabBtns.forEach(btn => {
      btn.classList.remove('stage-comp-tab--active', 'stage-comp-tab--without-active');
      if (btn.dataset.tab === tab) {
        btn.classList.add(
          tab === 'with' ? 'stage-comp-tab--active' : 'stage-comp-tab--without-active'
        );
      }
    });

    if (isManual) {
      fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
        },
        body: JSON.stringify({
          "eventName": "worsening_tab_switch",
          "eventAttributes": {
            "generalAttributes": {
              "platform": "web_shopify",
              "domain": "traya.health",
              "syntheticId": id || "default-id",
              "tab_name": tab === 'with' ? 'with traya' : 'without traya'
            }
          },
          "caseId": currentCaseId
        })
      });
    }
  }

  // ── Default: "With Traya" ─────────────────────────────────────────────────
  renderTab('with');

  // ── Auto-switch to "Without Traya" after 5s (unless user tapped first) ────
  let userInteracted = false;
  const autoTimer = setTimeout(() => {
    if (!userInteracted) renderTab('without');
  }, 5000);

  // ── Manual tab clicks ─────────────────────────────────────────────────────
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      userInteracted = true;
      clearTimeout(autoTimer);
      renderTab(btn.dataset.tab, true);
    });
  });
}



// ── initComparisonComponentV2 ────────────────────────────────────────────────
// STATE BEHAVIOUR (matches Figma screenshot exactly):
//
//  State 1 — CENTER (You're here):
//    • Thumb at 50% (middle of track)
//    • Center dot HIDDEN (thumb is on it)
//    • Both < and > arrows VISIBLE
//
//  State 0 — WITHOUT TRAYA (left):
//    • Thumb slides to LEFT end — sits exactly where < arrow is
//    • < arrow HIDDEN (thumb covers it)
//    • > arrow VISIBLE
//    • Center dot VISIBLE (orange dot at middle)
//
//  State 2 — WITH TRAYA (right):
//    • Thumb slides to RIGHT end — sits exactly where > arrow is
//    • > arrow HIDDEN (thumb covers it)
//    • < arrow VISIBLE
//    • Center dot VISIBLE (orange dot at middle)
//
// Auto-play: center → without → with → center → … (3s each)
// ────────────────────────────────────────────────────────────────────────────

function initComparisonComponentV2(response) {
  var User_Analysis   = response.User_Analysis;
  var stageTransition = response.stageTransition;

  if (!stageTransition || !stageTransition.current) return;

  var hairStage     = (User_Analysis && User_Analysis.hair_fall_stage
                        ? User_Analysis.hair_fall_stage.toLowerCase() : '');
  var currentCaseId = (User_Analysis && User_Analysis.case_id ? User_Analysis.case_id : '');
  var oldCreative   = document.querySelector('.stageWise-img');
  var compWrapper   = document.getElementById('stage-comparison-component-v2');

  // ── Gate ─────────────────────────────────────────────────────────────────
  function showFallback() {
    if (oldCreative) {
      oldCreative.classList.remove('d-none');
      oldCreative.style.setProperty('display', 'flex');
    }
    if (compWrapper) compWrapper.classList.add('d-none');
  }

  if (!(/^[0-7]/.test(currentCaseId)))                          { showFallback(); return; }
  if (!['hair thinning', 'side thinning'].includes(hairStage))  { showFallback(); return; }
  if (!compWrapper)                                               return;

  // ── Asset maps ───────────────────────────────────────────────────────────
  var IMAGES = {
    'hair thinning': {
      center : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/you-are-here-hair-thining.png?v=1774440228',
      with   : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/you-will-be-here-with-traya.png?v=1774440229',
      without: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Option_2_without_Traya.png?v=1774438594'
    },
    'side thinning': {
      center : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Side_thinning_you_are_here.png?v=1774440595',
      with   : 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Side_thinning_with_traya.png?v=1774440595',
      without: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Side_thinning_without_Traya_2.png?v=1774440595'
    }
  };

  var DESCS = {
    'hair thinning': {
      without: 'When hairfall is ignored for too long it leads to hair thinning & eventually scalp widening',
      center : 'Hairfall overtime leads to hair thinning & volume reduction.',
      with   : 'Traya works internally and externally to control hairfall and get hair volume back'
    },
    'side thinning': {
      without: 'When hairfall is ignored for too long it leads to hair thinning & eventually scalp widening',
      center : 'Hairfall overtime leads to hair thinning & volume reduction.',
      with   : 'Traya works internally and externally to control hairfall and get hair volume back'
    }
  };

  var STATE_KEYS = ['without', 'center', 'with'];

  // ── DOM refs ──────────────────────────────────────────────────────────────
  var blocks = [
    compWrapper.querySelector('.comp-v2-block--without'),
    compWrapper.querySelector('.comp-v2-block--center'),
    compWrapper.querySelector('.comp-v2-block--with')
  ];
  var withoutImg   = compWrapper.querySelector('#comp-v2-without-img');
  var centerImg    = compWrapper.querySelector('#comp-v2-center-img');
  var withImg      = compWrapper.querySelector('#comp-v2-with-img');
  var descEl       = compWrapper.querySelector('#comp-v2-desc');
  var thumb        = compWrapper.querySelector('#comp-v2-thumb');
  var track        = compWrapper.querySelector('#comp-v2-track');
  var centerDot    = compWrapper.querySelector('.comp-v2-center-dot');
  var prevBtn      = compWrapper.querySelector('#comp-v2-prev');
  var nextBtn      = compWrapper.querySelector('#comp-v2-next');
  var trackWrapper = compWrapper.querySelector('.comp-v2-track-wrapper');

  // ── Populate images ───────────────────────────────────────────────────────
  if (withoutImg) withoutImg.src = IMAGES[hairStage].without;
  if (centerImg)  centerImg.src  = IMAGES[hairStage].center;
  if (withImg)    withImg.src    = IMAGES[hairStage].with;

  // ── Inject styles once ────────────────────────────────────────────────────
  if (!document.getElementById('comp-v2-injected-style')) {
    var styleEl = document.createElement('style');
    styleEl.id  = 'comp-v2-injected-style';
    styleEl.textContent = [

      /* Thumb — left + translateX both driven by CSS vars */
      '#comp-v2-thumb {',
      '  position: absolute !important;',
      '  top: 50% !important;',
      '  left: var(--comp-thumb-left, 50%) !important;',
      '  transform: translate(var(--comp-thumb-tx, -42%), -50%) !important;',
      '  transition: left 2s cubic-bezier(.4,0,.2,1) !important;',
      '  z-index: 3 !important;',
      '  pointer-events: none !important;',
      '  justify-content: flex-end;',
      '}',

      /* Arrow buttons — fade out smoothly, layout preserved (no shift) */
      '#comp-v2-prev,',
      '#comp-v2-next {',
      '  transition: opacity 0.3s ease, visibility 0.3s ease !important;',
      '}',
      '#comp-v2-prev.comp-v2-arrow-gone,',
      '#comp-v2-next.comp-v2-arrow-gone {',
      '  opacity: 0 !important;',
      '  visibility: hidden !important;',
      '  pointer-events: none !important;',
      '}',

      /* Center dot — fade out smoothly */
      '.comp-v2-center-dot {',
      '  transition: opacity 0.3s ease !important;',
      '}',
      '.comp-v2-center-dot.comp-v2-dot-gone {',
      '  opacity: 0 !important;',
      '}'

    ].join('\n');
    document.head.appendChild(styleEl);
  }

  // ── Helper: get thumb left% to sit exactly over an arrow button ───────────
  function thumbLeftForState(s) {
    if (s === 1) return '50%';

    var trackRect = track.getBoundingClientRect();
    if (!trackRect || trackRect.width === 0) {
      return s === 0 ? '0%' : '100%';
    }

    var btn      = s === 0 ? prevBtn : nextBtn;
    var btnRect  = btn.getBoundingClientRect();
    var btnCentX = btnRect.left + btnRect.width / 2;
    var pct      = ((btnCentX - trackRect.left) / trackRect.width) * 100;

    return pct.toFixed(2) + '%';
  }

  // ── State vars ────────────────────────────────────────────────────────────
  var SEQUENCE               = [1, 0, 2];
  var seqStep                = 0;
  var state                  = 1;
  var userTouched            = false;
  var autoTimer              = null;
  var progressionEventFired  = false;  // ← fires once on first manual interaction

  // ── Tracking: component interaction (fires once) ──────────────────────────
  function fireHairProgressionEvent() {
    try {
      fetch('https://public-jgfas325.hav-g.in/eventMoengageWeb', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90'
        },
        body: JSON.stringify({
          eventName: 'hair_progression_component_clicked',
          eventAttributes: {
            generalAttributes: {
              platform   : 'web_shopify',
              domain     : 'traya.health',
              syntheticId: (typeof id !== 'undefined' ? id : 'default-id')
            }
          },
          caseId: currentCaseId
        })
      });
    } catch (e) { /* silent */ }
  }

  // ── Render ────────────────────────────────────────────────────────────────
  function render() {

    // Set translateX offset:
    //   state 0 (left / Without Traya) → -58% so thumb doesn't overhang left
    //   state 1 (center)               → -42% default
    //   state 2 (right / With Traya)   → -42% default
    compWrapper.style.setProperty(
      '--comp-thumb-tx',
      state === 0 ? '-58%' : '-42%'
    );

    // 1. Move thumb to exact position
    compWrapper.style.setProperty('--comp-thumb-left', thumbLeftForState(state));

    // 2. Active / inactive image blocks
    blocks.forEach(function(block, i) {
      if (!block) return;
      block.classList.toggle('comp-v2-block--active',   i === state);
      block.classList.toggle('comp-v2-block--inactive', i !== state);
    });

    // 3. Arrow visibility
    prevBtn.classList.toggle('comp-v2-arrow-gone', state === 0);
    nextBtn.classList.toggle('comp-v2-arrow-gone', state === 2);
    prevBtn.disabled = (state === 0);
    nextBtn.disabled = (state === 2);

    // 4. Center dot visibility — hidden only when thumb is over it (state 1)
    if (centerDot) {
      centerDot.classList.toggle('comp-v2-dot-gone', state === 1);
    }

    // 5. Description fade out → swap text → fade in
    descEl.classList.remove('comp-v2-desc--visible');
    var newText = DESCS[hairStage][STATE_KEYS[state]];
    setTimeout(function() {
      descEl.textContent = newText;
      descEl.classList.add('comp-v2-desc--visible');
    }, 200);
  }

  // ── Navigate ──────────────────────────────────────────────────────────────
  function goTo(s, manual) {
    if (s < 0 || s > 2 || s === state) return;
    state = s;
    if (manual) {
      userTouched = true;
      clearAutoPlay();

      // Fire once on first manual interaction
      if (!progressionEventFired) {
        progressionEventFired = true;
        fireHairProgressionEvent();
      }
    }
    render();
  }

  // ── Auto-play ─────────────────────────────────────────────────────────────
  function clearAutoPlay() {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }

  function startAutoPlay() {
    clearAutoPlay();
    autoTimer = setInterval(function() {
      if (userTouched) { clearAutoPlay(); return; }
      seqStep = (seqStep + 1) % SEQUENCE.length;
      state   = SEQUENCE[seqStep];
      render();
    }, 3000);
  }

  // ── Arrow click events ────────────────────────────────────────────────────
  prevBtn.addEventListener('click', function() { goTo(state - 1, true); });
  nextBtn.addEventListener('click', function() { goTo(state + 1, true); });

  // ── Track click — snap to nearest of 3 stops ─────────────────────────────
  if (trackWrapper) {
    trackWrapper.addEventListener('click', function(e) {
      if (isDragging) return;
      var rect    = track.getBoundingClientRect();
      var pct     = (e.clientX - rect.left) / rect.width;
      var clamped = Math.max(0, Math.min(1, pct));
      var nearest = clamped < 0.33 ? 0 : clamped < 0.66 ? 1 : 2;
      goTo(nearest, true);
    });
  }

  // ── Thumb drag (mouse + touch) ────────────────────────────────────────────
  var isDragging = false;

  function getClientX(e) {
    return e.touches ? e.touches[0].clientX : e.clientX;
  }

  function onDragStart(e) {
    isDragging  = true;
    userTouched = true;
    clearAutoPlay();
    thumb.style.setProperty('transition', 'none', 'important');
    e.preventDefault();
  }

  function onDragMove(e) {
    if (!isDragging) return;
    e.preventDefault();
    var rect    = track.getBoundingClientRect();
    var pct     = (getClientX(e) - rect.left) / rect.width;
    var clamped = Math.max(0, Math.min(1, pct));

    // Move thumb visually in real time
    compWrapper.style.setProperty('--comp-thumb-left', (clamped * 100).toFixed(2) + '%');

    // Update translateX live based on which third the thumb is in
    var nearest = clamped < 0.33 ? 0 : clamped < 0.66 ? 1 : 2;
    compWrapper.style.setProperty('--comp-thumb-tx', nearest === 0 ? '-58%' : '-42%');

    // Update arrows + center dot live
    prevBtn.classList.toggle('comp-v2-arrow-gone', nearest === 0);
    nextBtn.classList.toggle('comp-v2-arrow-gone', nearest === 2);
    if (centerDot) centerDot.classList.toggle('comp-v2-dot-gone', nearest === 1);
  }

  function onDragEnd(e) {
    if (!isDragging) return;
    isDragging = false;

    thumb.style.removeProperty('transition');

    var rect    = track.getBoundingClientRect();
    var clientX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    var pct     = (clientX - rect.left) / rect.width;
    var clamped = Math.max(0, Math.min(1, pct));
    var nearest = clamped < 0.33 ? 0 : clamped < 0.66 ? 1 : 2;

    goTo(nearest, true);
  }

 // Enable pointer events on thumb so it can be grabbed
thumb.style.setProperty('pointer-events', 'auto', 'important');  // ← updated
thumb.style.cursor = 'grab';

  // Mouse drag
  thumb.addEventListener('mousedown',    onDragStart);
  document.addEventListener('mousemove', onDragMove);
  document.addEventListener('mouseup',   onDragEnd);

  // Touch drag
  thumb.addEventListener('touchstart',    onDragStart, { passive: false });
  document.addEventListener('touchmove',  onDragMove,  { passive: false });
  document.addEventListener('touchend',   onDragEnd);

  // ── Activate component ────────────────────────────────────────────────────
  var femaleSection = document.querySelector('.female-test-report-section');
  if (femaleSection) femaleSection.classList.add('stage-comp-v2-active');

  if (oldCreative) oldCreative.style.setProperty('display', 'none', 'important');
  compWrapper.classList.remove('d-none');

  document.querySelectorAll(
    '.hair_thinning_week_text-container, .desktopDescription, .mobileDescription'
  ).forEach(function(el) {
    el.style.setProperty('display', 'none', 'important');
  });

  // ── Initial render ────────────────────────────────────────────────────────
  requestAnimationFrame(function() {
    thumb.style.setProperty('transition', 'none', 'important');
    compWrapper.style.setProperty('--comp-thumb-left', '50%');
    compWrapper.style.setProperty('--comp-thumb-tx', '-42%');

    requestAnimationFrame(function() {
      thumb.style.removeProperty('transition');
      render();
      startAutoPlay();
    });
  });
}

function fireResultPageLandedEvent(response) {
  const pathMatch = window.location.pathname.match(/\/pages\/([^/?]+)/);
  const result_variant = pathMatch ? pathMatch[1] : 'unknown';
  const form_variant = localStorage.getItem('traya_path_name') || '';

  const rawGender = response?.User_Analysis?.gender || '';
  const gender =
    rawGender === 'F' ? 'Female' : rawGender === 'M' ? 'Male' : rawGender;

  const caseId = response?.User_Analysis?.case_id || '';
  const urlParams = new URLSearchParams(window.location.search);
  const utm_source = urlParams.get('utm_source');
  const utm_medium = urlParams.get('utm_medium');
  const utm_campaign = urlParams.get('utm_campaign');
  const referrer = document.referrer;

  const eventPayload = {
    result_variant,
    form_variant,
    gender,
    case_id: caseId,
    page_url: window.location.href
  };

  if (utm_source)   eventPayload.utm_source   = utm_source;
  if (utm_medium)   eventPayload.utm_medium   = utm_medium;
  if (utm_campaign) eventPayload.utm_campaign = utm_campaign;
  if (referrer)     eventPayload.referrer     = referrer;

  if (typeof gtag === 'function') {
    gtag('event', 'result_page_landed', {
      send_to: 'G-KJK84KP0LJ',
      ...eventPayload,
    });
  }
}

function initWhyTrayaSection(response) {
  const section = document.querySelector('#why-is-traya-expensive-v2');
  if (!section) return;

  section.classList.remove('d-none');
  section.style.setProperty('display', 'block', 'important');

  const cartPrice = Math.round(response?.cart_price || 0);
  if (cartPrice > 0) {
    // Target the INNER total-price span only — leaves the / sibling alive
    const priceEl = section.querySelector('.witev2__price--traya .total-price');
    if (priceEl) {
      priceEl.textContent = `₹${cartPrice}`;
    }
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// APP DISCOUNT FLOW — D30+ web → app transition
// ─────────────────────────────────────────────────────────────────────────────

const APP_DISCOUNT_PERCENT = 5;
const APP_BRANCH_LINK      = 'https://trayahealth.app.link/xT3UrtZDvyb';

// Find the element the strip should sit ABOVE (inserted as a sibling before it)
function getAppDiscAnchor() {
  return document.querySelector('.price_model_discount.result4_sticky_model')
      || document.querySelector('.price_model_discount')
      || document.querySelector('.result4_sticky_model');
}

function initAppDiscountFlow(response) {
  // ── 1. Eligibility ────────────────────────────────────────────────────────
  const caseId = response?.User_Analysis?.case_id;
  if (!caseId || !/^[0-7]/.test(caseId)) return;

  // Exclude referral users — COMMENTED FOR TESTING, UNCOMMENT BEFORE PROD
  const hasReferralParam =
    getUrlParameter('referral') || getUrlParameter('ref') || getUrlParameter('referralCode');
  if (hasReferralParam || getCookie('referralCode')) return;

  // D30+ check — COMMENTED FOR TESTING, UNCOMMENT BEFORE PROD
  let formFillDateStr = response?.User_Analysis?.case_created_date;
  let formFillDate = new Date(formFillDateStr);
  if (isNaN(formFillDate.getTime())) {
    formFillDateStr = getCookie('current_D0_date');
    formFillDate = new Date(formFillDateStr);
  }
  if (isNaN(formFillDate.getTime())) return;

  const daysSinceFormFill = isNaN(formFillDate.getTime())
    ? 0
    : Math.floor((Date.now() - formFillDate.getTime()) / (1000 * 60 * 60 * 24));
  if (daysSinceFormFill < 30) return;

  // ── 2. Prices ─────────────────────────────────────────────────────────────
  const webPrice = Math.round(response?.cart_price || 0);
  if (!webPrice) return;
  const appPrice = Math.round(webPrice * (1 - APP_DISCOUNT_PERCENT / 100));

  // ── 3. Render strip + bottom sheet ────────────────────────────────────────
  renderAppDiscountStrip(caseId, daysSinceFormFill);
  renderAppDiscountBottomSheet(webPrice, appPrice, caseId, daysSinceFormFill);
}

// ── Moving strip ────────────────────────────────────────────────────────────
function renderAppDiscountStrip(caseId, daysSinceFormFill) {
  if (document.querySelector('.app-disc-strip')) return;

  const itemHTML = `
    <span class="app-disc-strip__item">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M2.86093 7.61521C2.71498 6.95774 2.73739 6.27406 2.92609 5.62755C3.1148 4.98105 3.46368 4.39266 3.9404 3.91694C4.41712 3.44121 5.00625 3.09356 5.65314 2.90621C6.30004 2.71886 6.98377 2.69788 7.64093 2.84521C8.00264 2.27952 8.50094 1.81397 9.08989 1.4915C9.67883 1.16903 10.3395 1 11.0109 1C11.6824 1 12.343 1.16903 12.932 1.4915C13.5209 1.81397 14.0192 2.27952 14.3809 2.84521C15.0391 2.69724 15.724 2.71812 16.3719 2.90593C17.0199 3.09373 17.6098 3.44236 18.0868 3.91937C18.5638 4.39638 18.9124 4.98629 19.1002 5.63422C19.288 6.28215 19.3089 6.96705 19.1609 7.62521C19.7266 7.98692 20.1922 8.48522 20.5146 9.07417C20.8371 9.66311 21.0061 10.3238 21.0061 10.9952C21.0061 11.6667 20.8371 12.3273 20.5146 12.9163C20.1922 13.5052 19.7266 14.0035 19.1609 14.3652C19.3083 15.0224 19.2873 15.7061 19.0999 16.353C18.9126 16.9999 18.5649 17.589 18.0892 18.0657C17.6135 18.5425 17.0251 18.8914 16.3786 19.0801C15.7321 19.2688 15.0484 19.2912 14.3909 19.1452C14.0297 19.7131 13.531 20.1806 12.9411 20.5045C12.3511 20.8284 11.689 20.9983 11.0159 20.9983C10.3429 20.9983 9.68076 20.8284 9.09081 20.5045C8.50086 20.1806 8.00217 19.7131 7.64093 19.1452C6.98377 19.2925 6.30004 19.2716 5.65314 19.0842C5.00625 18.8969 4.41712 18.5492 3.9404 18.0735C3.46368 17.5978 3.1148 17.0094 2.92609 16.3629C2.73739 15.7164 2.71498 15.0327 2.86093 14.3752C2.29089 14.0145 1.82135 13.5154 1.49598 12.9244C1.17062 12.3335 1 11.6698 1 10.9952C1 10.3206 1.17062 9.65696 1.49598 9.066C1.82135 8.47504 2.29089 7.97597 2.86093 7.61521Z" fill="#CF6C57"/>
        <path d="M14.0107 7.99512L8.01074 13.9951L14.0107 7.99512Z" fill="#CF6C57"/>
        <path d="M8.01074 7.99512H8.02074H8.01074Z" fill="#CF6C57"/>
        <path d="M14.0107 13.9951H14.0207H14.0107Z" fill="#CF6C57"/>
        <path d="M14.0107 7.99512L8.01074 13.9951M8.01074 7.99512H8.02074M14.0107 13.9951H14.0207M2.86093 7.61521C2.71498 6.95774 2.73739 6.27406 2.92609 5.62755C3.1148 4.98105 3.46368 4.39266 3.9404 3.91694C4.41712 3.44121 5.00624 3.09356 5.65314 2.90621C6.30004 2.71886 6.98377 2.69788 7.64093 2.84521C8.00264 2.27952 8.50094 1.81397 9.08989 1.4915C9.67883 1.16903 10.3395 1 11.0109 1C11.6824 1 12.343 1.16903 12.932 1.4915C13.5209 1.81397 14.0192 2.27952 14.3809 2.84521C15.0391 2.69724 15.724 2.71812 16.3719 2.90593C17.0199 3.09373 17.6098 3.44236 18.0868 3.91937C18.5638 4.39638 18.9124 4.98629 19.1002 5.63422C19.288 6.28214 19.3089 6.96705 19.1609 7.62521C19.7266 7.98692 20.1922 8.48522 20.5146 9.07417C20.8371 9.66311 21.0061 10.3238 21.0061 10.9952C21.0061 11.6667 20.8371 12.3273 20.5146 12.9163C20.1922 13.5052 19.7266 14.0035 19.1609 14.3652C19.3083 15.0224 19.2873 15.7061 19.0999 16.353C18.9126 16.9999 18.5649 17.589 18.0892 18.0657C17.6135 18.5425 17.0251 18.8914 16.3786 19.0801C15.7321 19.2688 15.0484 19.2912 14.3909 19.1452C14.0297 19.7131 13.531 20.1806 12.9411 20.5045C12.3511 20.8284 11.689 20.9983 11.0159 20.9983C10.3429 20.9983 9.68076 20.8284 9.09081 20.5045C8.50086 20.1806 8.00217 19.7131 7.64093 19.1452C6.98377 19.2925 6.30004 19.2716 5.65314 19.0842C5.00624 18.8969 4.41712 18.5492 3.9404 18.0735C3.46368 17.5978 3.1148 17.0094 2.92609 16.3629C2.73739 15.7164 2.71498 15.0327 2.86093 14.3752C2.29089 14.0145 1.82135 13.5154 1.49598 12.9244C1.17062 12.3335 1 11.6698 1 10.9952C1 10.3206 1.17062 9.65696 1.49598 9.066C1.82135 8.47504 2.29089 7.97597 2.86093 7.61521Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Get Extra <strong>${APP_DISCOUNT_PERCENT}% Discount</strong> on App
      <svg class="app-disc-strip__chevron" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#262626" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </span>
  `;
  const trackHTML = Array(8).fill(itemHTML).join('');

  const strip = document.createElement('div');
  strip.className = 'app-disc-strip';
  strip.setAttribute('role', 'button');
  strip.setAttribute('aria-label', `Get extra ${APP_DISCOUNT_PERCENT}% discount on app`);
  strip.innerHTML = `<div class="app-disc-strip__track">${trackHTML}</div>`;

  const anchor = getAppDiscAnchor();

  if (anchor && anchor.parentNode) {
    // Insert strip as a sibling RIGHT BEFORE the price_model_discount div
    strip.classList.add('app-disc-strip--contained');
    anchor.parentNode.insertBefore(strip, anchor);
  } else {
    // Fallback — fixed position anchored to sticky button
    document.body.appendChild(strip);

    const positionStrip = () => {
      const stickyBtn = document.querySelector('[sticky__btn]') || document.querySelector('[btn_sticky]');
      if (stickyBtn) {
        const rect = stickyBtn.getBoundingClientRect();
        strip.style.bottom = (stickyBtn.offsetHeight || 0) + 'px';
        strip.style.left   = rect.left + 'px';
        strip.style.width  = rect.width + 'px';
        strip.style.right  = 'auto';
      } else {
        strip.style.bottom = '0';
        strip.style.left   = '0';
        strip.style.right  = '0';
        strip.style.width  = '';
      }
    };
    positionStrip();
    window.addEventListener('resize', positionStrip);
    setTimeout(positionStrip, 500);
    setTimeout(positionStrip, 1500);
  }

  // App discount strip is showing → hide the default price model discount.
  // Only runs for eligible users, since ineligible ones return early in
  // initAppDiscountFlow and never reach this function.
  document.querySelectorAll('.price_model_discount').forEach(el => {
    el.style.setProperty('display', 'none', 'important');
  });

  strip.addEventListener('click', () => {
    fireAppDiscEvent('app_exclusive_discount_strip_clicked', caseId, daysSinceFormFill);
    openAppDiscountBottomSheet();
  });
}
function renderAppDiscountBottomSheet(webPrice, appPrice, caseId, daysSinceFormFill) {
  if (document.getElementById('app-disc-sheet')) return;

  const overlay = document.createElement('div');
  overlay.id = 'app-disc-overlay';

  const sheet = document.createElement('div');
  sheet.id = 'app-disc-sheet';
  sheet.innerHTML = `
    <span class="app-disc-sheet__badge">
      <svg xmlns="http://www.w3.org/2000/svg" width="98" height="98" viewBox="0 0 98 98" fill="none">
        <path d="M15.7238 35.1996C15.1278 32.5149 15.2193 29.7232 15.9899 27.0833C16.7604 24.4435 18.185 22.0409 20.1316 20.0983C22.0783 18.1558 24.4838 16.7362 27.1253 15.9712C29.7668 15.2062 32.5587 15.1205 35.2422 15.7221C36.7191 13.4122 38.7538 11.5112 41.1587 10.1945C43.5636 8.87769 46.2612 8.1875 49.003 8.1875C51.7448 8.1875 54.4424 8.87769 56.8473 10.1945C59.2521 11.5112 61.2868 13.4122 62.7638 15.7221C65.4513 15.1179 68.248 15.2032 70.8937 15.97C73.5394 16.7369 75.9482 18.1605 77.896 20.1083C79.8438 22.0561 81.2674 24.4648 82.0342 27.1105C82.8011 29.7563 82.8864 32.5529 82.2822 35.2405C84.5921 36.7174 86.493 38.7521 87.8098 41.157C89.1266 43.5619 89.8168 46.2595 89.8168 49.0013C89.8168 51.7431 89.1266 54.4407 87.8098 56.8456C86.493 59.2504 84.5921 61.2851 82.2822 62.7621C82.8838 65.4456 82.7981 68.2375 82.0331 70.879C81.2681 73.5204 79.8485 75.926 77.906 77.8726C75.9634 79.8192 73.5608 81.2439 70.9209 82.0144C68.281 82.7849 65.4893 82.8765 62.8047 82.2805C61.3296 84.5993 59.2933 86.5084 56.8843 87.831C54.4754 89.1537 51.7716 89.8471 49.0234 89.8471C46.2752 89.8471 43.5714 89.1537 41.1625 87.831C38.7535 86.5084 36.7172 84.5993 35.2422 82.2805C32.5587 82.8821 29.7668 82.7964 27.1253 82.0314C24.4838 81.2664 22.0783 79.8468 20.1316 77.9043C18.185 75.9617 16.7604 73.5591 15.9899 70.9192C15.2193 68.2794 15.1278 65.4876 15.7238 62.803C13.3961 61.3299 11.4788 59.292 10.1503 56.8789C8.82169 54.4658 8.125 51.7559 8.125 49.0013C8.125 46.2466 8.82169 43.5367 10.1503 41.1237C11.4788 38.7106 13.3961 36.6727 15.7238 35.1996Z" fill="#CF6C57"/>
        <path d="M61.2522 36.7509L36.7522 61.2509L61.2522 36.7509Z" fill="#CF6C57"/>
        <path d="M36.7522 36.7509H36.793H36.7522Z" fill="#CF6C57"/>
        <path d="M61.2522 61.2509H61.293H61.2522Z" fill="#CF6C57"/>
        <path d="M61.2522 36.7509L36.7522 61.2509M36.7522 36.7509H36.793M61.2522 61.2509H61.293M15.7238 35.1996C15.1278 32.5149 15.2193 29.7232 15.9899 27.0833C16.7604 24.4435 18.185 22.0409 20.1316 20.0983C22.0783 18.1558 24.4838 16.7362 27.1253 15.9712C29.7668 15.2062 32.5587 15.1205 35.2422 15.7221C36.7191 13.4122 38.7538 11.5112 41.1587 10.1945C43.5636 8.87769 46.2612 8.1875 49.003 8.1875C51.7447 8.1875 54.4424 8.87769 56.8473 10.1945C59.2521 11.5112 61.2868 13.4122 62.7638 15.7221C65.4513 15.1179 68.248 15.2032 70.8937 15.97C73.5394 16.7369 75.9482 18.1605 77.896 20.1083C79.8438 22.0561 81.2674 24.4648 82.0342 27.1106C82.8011 29.7563 82.8864 32.5529 82.2822 35.2405C84.5921 36.7174 86.4931 38.7521 87.8098 41.157C89.1266 43.5619 89.8168 46.2595 89.8168 49.0013C89.8168 51.7431 89.1266 54.4407 87.8098 56.8456C86.4931 59.2504 84.5921 61.2851 82.2822 62.7621C82.8838 65.4456 82.7981 68.2375 82.0331 70.879C81.2681 73.5204 79.8485 75.926 77.906 77.8726C75.9634 79.8192 73.5608 81.2439 70.9209 82.0144C68.281 82.7849 65.4893 82.8765 62.8047 82.2805C61.3296 84.5992 59.2933 86.5084 56.8843 87.831C54.4754 89.1537 51.7716 89.8471 49.0234 89.8471C46.2752 89.8471 43.5714 89.1537 41.1625 87.831C38.7535 86.5084 36.7172 84.5992 35.2422 82.2805C32.5587 82.8821 29.7668 82.7964 27.1253 82.0314C24.4838 81.2664 22.0783 79.8468 20.1316 77.9043C18.185 75.9617 16.7604 73.5591 15.9899 70.9192C15.2193 68.2794 15.1278 65.4876 15.7238 62.803C13.3961 61.3299 11.4788 59.292 10.1503 56.8789C8.82169 54.4658 8.125 51.7559 8.125 49.0013C8.125 46.2466 8.82169 43.5367 10.1503 41.1237C11.4788 38.7106 13.3961 36.6727 15.7238 35.1996Z" stroke="white" stroke-width="8.16667" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <div class="app-disc-sheet__body">
      <h2 class="app-disc-sheet__title">Unlock ${APP_DISCOUNT_PERCENT}% off</h2>
      <p class="app-disc-sheet__subtitle">Exclusive App Discount</p>

      <div class="app-disc-sheet__prices">
        <div class="app-disc-sheet__price-col">
          <p class="app-disc-sheet__price-amt">₹ ${webPrice}</p>
          <p class="app-disc-sheet__price-label">Your kit price<br>on web</p>
        </div>
        <div class="app-disc-sheet__divider"></div>
        <div class="app-disc-sheet__price-col">
          <p class="app-disc-sheet__price-amt app-disc-sheet__price-amt--app">₹ ${appPrice}</p>
          <p class="app-disc-sheet__price-label">Your kit price<br>on <strong>App</strong></p>
        </div>
      </div>

      <p class="app-disc-sheet__perks-title">Additionally the app also provide</p>
      <div class="app-disc-sheet__perks">
        <div class="app-disc-sheet__perk">
          Free Diet plan to support your treatment
          <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_15_05a586c2-0445-47bb-9ee2-ff5503449995.webp?v=1779698840" alt="">
        </div>
        <div class="app-disc-sheet__perk">
          Daily log and earn for future discounts
          <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Screen_Replace_here_1.png?v=1779707141" alt="">
        </div>
      </div>

      <button class="app-disc-sheet__cta-primary" data-cta="go-to-app">Go to App</button>
      <button class="app-disc-sheet__cta-secondary" data-cta="continue-on-web">Continue on web</button>
    </div>
  `;

  document.body.appendChild(overlay);
  document.body.appendChild(sheet);

  const close = () => closeAppDiscountBottomSheet();
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sheet.classList.contains('app-disc-open')) close();
  });

  sheet.querySelector('[data-cta="go-to-app"]').addEventListener('click', () => {
    fireAppDiscEvent('app_exclusive_discount_bs_clicked', caseId, daysSinceFormFill, 'Go to app');
    window.location.href = `${APP_BRANCH_LINK}?caseId=${encodeURIComponent(caseId)}`;
  });

  sheet.querySelector('[data-cta="continue-on-web"]').addEventListener('click', () => {
    fireAppDiscEvent('app_exclusive_discount_bs_clicked', caseId, daysSinceFormFill, 'Continue on web');
    close();
    setTimeout(() => {
      if (window.appliedReferralCode) {
        window.location.href = `/checkout?discount=${window.appliedReferralCode}`;
      } else {
        window.location.href = '/checkout';
      }
    }, 200);
  });
}

function openAppDiscountBottomSheet() {
  const overlay = document.getElementById('app-disc-overlay');
  const sheet   = document.getElementById('app-disc-sheet');
  if (!overlay || !sheet) return;
  overlay.style.display = 'block';
  sheet.style.display = 'block';
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => sheet.classList.add('app-disc-open'));
}

function closeAppDiscountBottomSheet() {
  const overlay = document.getElementById('app-disc-overlay');
  const sheet   = document.getElementById('app-disc-sheet');
  if (!overlay || !sheet) return;
  sheet.classList.remove('app-disc-open');
  setTimeout(() => {
    overlay.style.display = 'none';
    sheet.style.display = 'none';
    document.body.style.overflow = '';
  }, 320);
}

function fireAppDiscEvent(eventName, caseID, daysSinceFormFill, ctaValue) {
  const syntheticId = window.location.search.substring(1).split('=')[1] || 'default-id';
  const attrs = {
    platform: 'web_shopify',
    domain: 'traya.health',
    syntheticId,
    caseID,
    daysSinceFormFill
  };
  if (ctaValue) attrs.CTA = ctaValue;

  fetch('https://public-jgfas325.hav-g.in/eventMoengageWeb', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90'
    },
    body: JSON.stringify({
      eventName,
      eventAttributes: { generalAttributes: attrs },
      caseId: caseID
    })
  });
}


function initTrayaScienceV2BannerPopup() {
  const bannerLink = document.querySelector('.traya-science-v2-banner-link');
  if (!bannerLink) return;
  bannerLink.classList.remove('d-none');

  if (!document.getElementById('tsv2-popup')) {
    document.body.insertAdjacentHTML('beforeend', `
      <style>
        #tsv2-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.55); z-index:10000; }
        #tsv2-popup {
          position: fixed;
          background: #fff;
          z-index: 99999;
          overflow-y: auto;
          opacity: 0;
          transition: transform 0.35s ease, opacity 0.35s ease;
        }

        /* Desktop — centered modal */
        @media (min-width: 768px) {
          #tsv2-popup {
            top: 50%; left: 50%;
            width: 812px;
            max-height: 85vh;
            border-radius: 16px;
            transform: translate(-50%, -50%) scale(0.85);
          }
          #tsv2-popup.tsv2-open {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
        }

        /* Mobile — bottom sheet */
        @media (max-width: 767px) {
          #tsv2-popup {
            left: 0; right: 0; bottom: 0;
            max-height: 75vh;
            border-radius: 16px 16px 0 0;
            transform: translateY(100%);
          }
          #tsv2-popup.tsv2-open {
            transform: translateY(0);
            opacity: 1;
          }
        }
      </style>
      <div id="tsv2-overlay"></div>
      <div id="tsv2-popup">
        <div style="position:sticky;top:0;height:0;z-index:3;pointer-events:none;">
          <div style="position:absolute;top:8px;left:0;right:0;display:flex;justify-content:center;"><span style="width:72px;height:4px;flex-shrink:0;border-radius:100px;background:#DEDEDE;"></span></div>
          <button id="tsv2-close" aria-label="Close" style="position:absolute;top:12px;right:16px;pointer-events:auto;display:flex;width:32px;height:32px;padding:0;justify-content:center;align-items:center;gap:10px;border-radius:999px;opacity:0.8;background:#FFF;border:none;cursor:pointer;flex-shrink:0;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div id="tsv2-content" style="padding:0"></div>
      </div>
    `);
  }

  const overlay = document.getElementById('tsv2-overlay');
  const popup   = document.getElementById('tsv2-popup');
  const content = document.getElementById('tsv2-content');
  let cache        = null;
  let fetchPromise = null;

  function ensureSlickCSS() {
    ['slick.css', 'slick-theme.css'].forEach(function(f) {
      const href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/' + f;
      if (!document.querySelector('link[href="' + href + '"]')) {
        const link = document.createElement('link');
        link.rel  = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });
  }

  function load() {
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch('/pages/hair-growth-science?pb=0')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!document.getElementById('tsv2-styles')) {
          const wrap = document.createElement('div');
          wrap.id = 'tsv2-styles';
          doc.querySelectorAll('head style').forEach(function(s) {
            const st = document.createElement('style');
            st.textContent = s.textContent;
            wrap.appendChild(st);
          });
          document.head.appendChild(wrap);
        }
        cache = (doc.querySelector('main') || doc.body).innerHTML;
        return cache;
      })
      .catch(function(err) { console.error('TSV2 fetch failed:', err); fetchPromise = null; });
  }

  function render() {
    content.innerHTML = cache;
    content.querySelectorAll('script').forEach(function(old) {
      if (old.textContent.indexOf('cs-slider') > -1) return;
      const s = document.createElement('script');
      if (old.src) { s.src = old.src; s.async = false; }
      else { s.textContent = old.textContent; }
      document.body.appendChild(s);
    });
    ensureSlickCSS();
    waitAndInitCSSlider();
  }

  function waitAndInitCSSlider() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(waitAndInitCSSlider, 100);
      return;
    }
    setTimeout(function() {
      const $s = jQuery('#tsv2-popup .cs-slider');
      if (!$s.length) { console.warn('TSV2: .cs-slider not found in popup'); return; }
      if ($s.hasClass('slick-initialized')) { $s.slick('unslick'); }
      const $dots  = jQuery('#tsv2-popup .cs-dots');
      const $label = jQuery('#tsv2-popup .cs-dot-label');
      $s.slick({
        slidesToShow: 2.2, slidesToScroll: 1, centerMode: false,
        dots: false, arrows: false,
        infinite: false, autoplay: true, autoplaySpeed: 2500, speed: 600,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 2.2, centerMode: false } },
          { breakpoint: 768,  settings: { slidesToShow: 1.2, centerMode: false } }
        ]
      });
      const total = $s.slick('getSlick').slideCount;
      $dots.empty();
      for (var _d = 0; _d < total; _d++) {
        jQuery('<button type="button" class="cs-mdot" aria-label="Go to slide ' + (_d + 1) + '"></button>')
          .toggleClass('is-active', _d === 0)
          .appendTo($dots);
      }
      $dots.on('click', '.cs-mdot', function() { $s.slick('slickGoTo', jQuery(this).index()); });
      if ($label.length) $label.text('1 / ' + total);
      $s.on('afterChange', function(e, slick, i) {
        $dots.find('.cs-mdot').removeClass('is-active').eq(i).addClass('is-active');
        if ($label.length) $label.text((i + 1) + ' / ' + slick.slideCount);
      });
      console.log('TSV2: CS slider initialised with', total, 'slides');
    }, 200);
  }

  function open() {
    overlay.style.display        = 'block';
    popup.style.display          = 'block';
    document.body.style.overflow = 'hidden';
    popup.scrollTop              = 0;
    requestAnimationFrame(() => popup.classList.add('tsv2-open'));
    chatIconClicked("traya_science_thinning_v2_banner_click", caseId);
    load().then(() => render());
  }

  function close() {
    popup.classList.remove('tsv2-open');
    setTimeout(function() {
      overlay.style.display = 'none';
      popup.style.display   = 'none';
    }, 350);
    document.body.style.overflow = '';
  }

  bannerLink.addEventListener('click', function(e) { e.preventDefault(); open(); });
  document.getElementById('tsv2-close').addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

  load();
}
// ── Money-back guarantee banner (Widening cohort, case_id 0-7 A/B) ──
function initMoneybackBanner(response) {
  const mbgCaseId = response?.User_Analysis?.case_id || '';
  const mbgStage = (response?.User_Analysis?.hair_fall_stage || '').toLowerCase();
  const wideningStages = ['widening', 'starting to see widening', 'medium widening', 'advanced widening', 'coin size patches', 'coin sized patches', 'alopecia areata'];
  // MBG "Get Results or Get 100% Refund" banner DISABLED — no case_id matches /^[^0-9a-f]/.
  // Re-enable: restore /^[0-7]/ (50% A/B) or use /^[0-9a-f]/ (100%).
  if (!wideningStages.includes(mbgStage) || !/^[^0-9a-f]/.test(mbgCaseId)) return;

  const banner = document.getElementById('mbgRefundBanner');
  const overlay = document.getElementById('mbgSheetOverlay');
  const content = document.getElementById('mbgSheetContent');
  const closeBtn = document.getElementById('mbgSheetClose');
  if (!banner || !overlay || !content || !closeBtn) return;

  let policyLoaded = false;
  banner.classList.remove('d-none');

  function openMbgSheet() {
    overlay.classList.add('mbg-open');
    document.body.style.overflow = 'hidden';
    if (!policyLoaded) {
      policyLoaded = true;
      fetch('/pages/money-back-policy')
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const policy = doc.querySelector('.fetch-page-content');
          content.innerHTML = policy
            ? policy.outerHTML
            : '<p>Unable to load the policy. <a href="/pages/money-back-policy">Open the policy page</a>.</p>';
        })
        .catch(() => {
          policyLoaded = false;
          content.innerHTML = '<p>Unable to load the policy. <a href="/pages/money-back-policy">Open the policy page</a>.</p>';
        });
    }
    fireMoneybackGuaranteeEvent(mbgCaseId);
  }

  function closeMbgSheet() {
    overlay.classList.remove('mbg-open');
    document.body.style.overflow = '';
  }

  // Eligibility-period table toggle. The injected policy markup ships an
  // .open-table "Click here" trigger + a hidden #tableModal, but the policy
  // page's own JS isn't loaded here — replicate the show/hide behaviour.
  content.addEventListener('click', function (e) {
    const opener = e.target.closest('.open-table');
    if (opener) {
      e.preventDefault();
      const modal = content.querySelector('#tableModal');
      if (modal) {
        modal.style.display = 'block';
        modal.style.zIndex = '100001';
      }
      return;
    }
    if (e.target.closest('.tableClose') || e.target.id === 'tableModal') {
      const modal = content.querySelector('#tableModal');
      if (modal) modal.style.display = 'none';
    }
  });

  banner.addEventListener('click', openMbgSheet);
  closeBtn.addEventListener('click', closeMbgSheet);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeMbgSheet(); });
}

function fireMoneybackGuaranteeEvent(caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": "web_moneyback_guarantee_click",
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

function setupTrayaForeverFaq(caseId, response) {
  const trayaFaqSection = document.querySelector('.traya-faq');
  if (!trayaFaqSection) return;

  // Shown to 100% of the thinning cohort (all case_ids, including age 18–24).
  trayaFaqSection.style.display = '';

  // ── Scoped layout tweaks — only when Traya Forever FAQ is active ──────────
  const faqTrigger = trayaFaqSection.querySelector('.traya-faq__trigger');
  if (faqTrigger) {
    // <button> width:auto sizes to its content, leaving an uneven right gap.
    // Fill the row minus equal 16px side margins instead.
    faqTrigger.style.boxSizing = 'border-box';
    faqTrigger.style.width = 'calc(100% - 32px)';
    faqTrigger.style.margin = '16px';
  }

  const externalContainer = document.querySelector('.combo-section.external-products-container');
  if (externalContainer) externalContainer.style.setProperty('padding-bottom', '0', 'important');

  // Dynamically swap the center maintenance kit image if Minoxidil or
  // Hair Active Serum is recommended in the user's kit.
  updateMaintenanceKitImages(trayaFaqSection, response);

  // Place FAQ after the kit (incl. Freebie), before "For complete hair care"
  const internalProductsWrapper = document.querySelector('.internal-products-wrapper-bg');
  if (internalProductsWrapper && internalProductsWrapper.nextElementSibling !== trayaFaqSection) {
    internalProductsWrapper.insertAdjacentElement('afterend', trayaFaqSection);
  }

  const trigger = trayaFaqSection.querySelector('[data-popup-open]');
  if (!trigger) return;

  if (trigger.dataset.trayaForeverBound === 'true') return;
  trigger.dataset.trayaForeverBound = 'true';

  trigger.addEventListener('click', () => {
    const syntheticId =
      window.location.search.substring(1).split('=')[1] || 'default-id';
    fireTrayaForeverEvent('web_traya_forever_clicked', caseId, syntheticId);
  });
}

function updateMaintenanceKitImages(trayaFaqSection, response) {
  const wideningStages = [
    'no widening',
    'starting to see widening',
    'medium widening',
    'advanced widening'
  ];
  const stage = (userHairStage || '').toLowerCase();
  const isWidening = wideningStages.includes(stage);

  trayaFaqSection.classList.toggle('traya-faq--scaled-up', isWidening);

  // ─── Center image swap when Minoxidil / Hair Active is in the kit ──────
  const sectionId = trayaFaqSection.dataset.sectionId;
  const popup = sectionId
    ? document.getElementById(`TrayaFaqPopup-${sectionId}`)
    : null;

  const productsContainer =
    (popup && popup.querySelector('.traya-faq__products')) ||
    trayaFaqSection.querySelector('.traya-faq__products');

  if (!productsContainer) return;

  const swappableProduct = productsContainer.querySelector(
    '[data-alternate-image], [data-alternate-image-hair-active]'
  );
  if (!swappableProduct) return;

  const kitContainer = document.querySelector('.product-combo-details');
  if (!kitContainer) return;

  const kitCards = kitContainer.querySelectorAll('.kit-card-container');
  const kitNames = Array.from(kitCards).map(card =>
    (card.dataset.productName || '').toLowerCase()
  );

  const hasMinoxidil  = kitNames.some(name => name.includes('minoxidil'));
  const hasHairActive = kitNames.some(name => name.includes('hair active'));

  let alternateSrc = null;
  let alternateAlt = null;

  if (hasMinoxidil && swappableProduct.dataset.alternateImage) {
    alternateSrc = swappableProduct.dataset.alternateImage;
    alternateAlt = swappableProduct.dataset.alternateAlt || 'Minoxidil';
  } else if (hasHairActive && swappableProduct.dataset.alternateImageHairActive) {
    alternateSrc = swappableProduct.dataset.alternateImageHairActive;
    alternateAlt = swappableProduct.dataset.alternateAltHairActive || 'Hair Active Serum';
  }

  if (!alternateSrc) return;

  let img = swappableProduct.querySelector('img');
  if (!img) {
    const placeholder = swappableProduct.querySelector('.traya-faq__product-placeholder');
    if (placeholder) placeholder.remove();
    img = document.createElement('img');
    img.className = 'traya-faq__product-img';
    img.loading = 'lazy';
    swappableProduct.appendChild(img);
  }

  img.src = alternateSrc;
  img.alt = alternateAlt;
  img.removeAttribute('srcset');
  img.removeAttribute('sizes');
}

function fireTrayaForeverEvent(eventName, caseID, syntheticID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": syntheticID
        }
      },
      "caseId": caseID
    })
  });
}

// ── Results scroll-progress bar (Thinning cohort, case_id 0-3) ──────────────
function initResultsProgressBar(response) {
  const stage = (response?.User_Analysis?.hair_fall_stage || '').toLowerCase();
  const caseId = String(response?.User_Analysis?.case_id || '');
  const thinningStages = ['hair thinning', 'side thinning'];
  // 100% of the thinning / side-thinning cohort (no case_id restriction)...
  if (!thinningStages.includes(stage)) return;
  // ...but D0 leads only — hide for D+ (case created / form filled > 24h ago).
  // Same D0/D+ split used elsewhere on this page.
  let formFillDateStr = response?.User_Analysis?.case_created_date;
  let formFillDate = new Date(formFillDateStr);
  if (isNaN(formFillDate.getTime())) {
    formFillDateStr = getCookie('current_D0_date');
    formFillDate = new Date(formFillDateStr);
  }
  const oneDay = 24 * 60 * 60 * 1000;
  const isD0 = !isNaN(formFillDate.getTime()) && (new Date() - formFillDate) <= oneDay;
  if (!isD0) return;

  const bar = document.getElementById('resultsProgressBar');
  const fill = document.getElementById('rpbFill');
  const spacer = document.getElementById('rpbSpacer');
  if (!bar || !fill) return;

  bar.classList.remove('d-none');
  const steps = Array.prototype.slice.call(bar.querySelectorAll('.rpb-step'));
  const track = bar.querySelector('.rpb-track');
  const syntheticId = window.location.search.substring(1).split('=')[1] || 'default-id';
  let barTopOffset = bar.offsetTop;

  // default progress (no step selected yet) -> 0, per analytics requirement
  if (!window.__resultsLastProgressCircle) window.__resultsLastProgressCircle = '0';

  // Fill the gold timeline to the full width of a given step (its right edge),
  // measured from real geometry so it stays correct when a step is hidden
  // (e.g. "Your Kit" on desktop) or the layout reflows.
  function setFillToStep(stepEl) {
    if (!stepEl || !track) return;
    // Last visible step always fills the whole track to 100%.
    const visible = steps.filter(function (s) { return getComputedStyle(s).display !== 'none'; });
    if (visible.length && visible[visible.length - 1] === stepEl) {
      fill.style.width = '100%';
      return;
    }
    const tr = track.getBoundingClientRect();
    if (tr.width <= 0) return;
    const sr = stepEl.getBoundingClientRect();
    // Fill to the step's right edge + a little extra so it reads as "reached".
    let w = ((sr.right - tr.left) / tr.width) * 100 + 1;
    fill.style.width = Math.max(5, Math.min(100, w)) + '%';
  }

  // Left edge of the desktop sticky "Your Kit" panel (.combo-builder), or null
  // when it isn't a fixed right-side panel (mobile / not shown). Used to keep the
  // progress bar from overlapping it at narrower desktop widths.
  function kitLeftEdge() {
    const kit = document.querySelector('.combo-builder');
    if (!kit) return null;
    const cs = getComputedStyle(kit);
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return null;
    if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    const r = kit.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return null;
    if (r.left < window.innerWidth * 0.4) return null; // full-width / not a right panel
    return r.left;
  }

  // Scroll-depth at which each circle becomes active. Kept a few % BELOW the
  // click targets (scrollPoints) so a click reliably activates its step — the
  // smooth-scroll settles a hair short of the target (e.g. 49.97% for a 50%
  // target), which previously left the fill stuck on the knife-edge (mobile).
  const enterPoints = [0, 15, 45, 85];
  // Scroll-depth a circle jumps to on click (Your Questions lands a bit deeper).
  const scrollPoints = [0, 20, 50, 92];

  // A site header would otherwise cover the frozen bar — sit below it. Return the
  // bottom of whichever header is currently occupying the top of the viewport.
  // Note: we DON'T require position:fixed/sticky — on initial load the header may
  // still be in normal flow (or its fixed positioning not yet applied), and a
  // strict check returned 0, pinning the bar at top:0 over the header until the
  // first scroll. Any header visible at the very top counts.
  const headerSelectors = ['#shopify-section-header', '#myHeader', 'header', '.site-header'];
  function headerOffset() {
    let headerH = 0;
    for (let i = 0; i < headerSelectors.length; i++) {
      const el = document.querySelector(headerSelectors[i]);
      if (!el) continue;
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      const r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > 1) return r.bottom;
      if (!headerH && r.height > 1) headerH = r.height; // remember for the fallback
    }
    // Near the top, if no header was detected pinned at the top yet (its fixed
    // positioning may not have settled on first paint), fall back to the header's
    // height so the bar sits just below it instead of overlapping at top:0.
    if ((window.scrollY || 0) <= 2 && headerH) return headerH;
    return 0;
  }

  function update() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docH = document.documentElement.scrollHeight - window.innerHeight;
    const pct = docH > 0 ? Math.min(100, Math.max(0, (scrollTop / docH) * 100)) : 0;
    // Activate each circle once its scroll segment is reached, and fill the
    // timeline to the full width of the deepest active *visible* step.
    let activeVisible = null;
    steps.forEach(function (s, i) {
      const on = pct >= enterPoints[i];
      s.classList.toggle('rpb-step--active', on);
      if (on && getComputedStyle(s).display !== 'none') activeVisible = s;
    });
    setFillToStep(activeVisible);

    // Freeze just below the header once scrolled past the bar's original position.
    const hOff = headerOffset();
    const GAP = 16;            // breathing room before the sticky kit panel
    const kitL = kitLeftEdge();
    if (scrollTop >= barTopOffset - hOff) {
      if (!bar.classList.contains('rpb--fixed')) {
        spacer.style.height = bar.offsetHeight + 'px';
        // inline display beats base.css `div:empty { display:none }`
        spacer.style.display = 'block';
        spacer.classList.remove('d-none');
        bar.classList.add('rpb--fixed');
      }
      // Match the in-flow container geometry (the spacer holds its spot) so the
      // frozen bar keeps the content-column width instead of full viewport.
      const ref = spacer.getBoundingClientRect();
      let width = ref.width;
      // Never run under the desktop sticky "Your Kit" panel on the right.
      if (kitL != null && ref.left + width > kitL - GAP) width = Math.max(0, kitL - GAP - ref.left);
      bar.style.top = hOff + 'px';
      bar.style.left = ref.left + 'px';
      bar.style.width = width + 'px';
    } else {
      if (bar.classList.contains('rpb--fixed')) {
        bar.classList.remove('rpb--fixed');
        bar.style.top = '';
        bar.style.left = '';
        spacer.style.display = 'none';
        spacer.classList.add('d-none');
      }
      // In-flow: cap width so the bar doesn't slide under the fixed kit panel.
      const host = bar.parentElement.getBoundingClientRect();
      if (kitL != null && host.right > kitL - GAP) {
        bar.style.width = Math.max(0, (kitL - GAP) - host.left) + 'px';
      } else {
        bar.style.width = '';
      }
    }
  }

  // Re-run after late layout shifts (header fixing, fonts/images, kit positioning)
  // settle, so the bar sits correctly below the header without needing a scroll.
  window.addEventListener('load', update);
  [100, 300, 600, 1000, 1800, 2600].forEach(function (ms) { setTimeout(update, ms); });

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', function () {
    if (!bar.classList.contains('rpb--fixed')) barTopOffset = bar.offsetTop;
    update();
  });
  update();

  steps.forEach(function (s, i) {
    s.addEventListener('click', function () {
      const sectionName = s.getAttribute('data-rpb-section');
      window.__resultsLastProgressCircle = s.getAttribute('data-rpb-pct') + '%';
      fireResultsProgressCircleEvent(caseId, syntheticId, sectionName);

      // Fill the timeline to the full width of the clicked step immediately
      // (the scroll settle keeps it filled — enterPoints sit below scrollPoints).
      steps.forEach(function (st, j) { st.classList.toggle('rpb-step--active', j <= i); });
      setFillToStep(s);

      // Scroll to the circle's target scroll depth (0 / 20 / 50 / 92%).
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      const top = docH * (scrollPoints[i] / 100);
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });
}

function fireResultsProgressCircleEvent(caseID, syntheticID, sectionName) {
  fetch('https://public-jgfas325.hav-g.in/eventMoengageWeb', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90'
    },
    body: JSON.stringify({
      eventName: 'web_results_progress_circle_click',
      eventAttributes: {
        generalAttributes: {
          platform: 'web_shopify',
          domain: 'traya.health',
          syntheticId: syntheticID,
          section_name: sectionName
        }
      },
      caseId: caseID
    })
  });
}

function fireResultsBuyNowEvent(response) {
  const caseID = response?.User_Analysis?.case_id || '';
  const syntheticID = window.location.search.substring(1).split('=')[1] || 'default-id';
  fetch('https://public-jgfas325.hav-g.in/eventMoengageWeb', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90'
    },
    body: JSON.stringify({
      eventName: 'web_results_buy_now_click',
      eventAttributes: {
        generalAttributes: {
          platform: 'web_shopify',
          domain: 'traya.health',
          syntheticId: syntheticID,
          lastest_progress: window.__resultsLastProgressCircle || '0'
        }
      },
      caseId: caseID
    }),
    keepalive: true
  });
}

/* ===== CS Clinical Study: results popup + slider (ported from new-female-result4-march.js for female-result4) ===== */
function initResultsSlider(selector) {
  const $slider = $(selector);
  if (!$slider.length) return;
  if ($slider.hasClass('slick-initialized')) return;

  $slider.on('init reInit afterChange', function(event, slick, currentSlide) {
    const current = currentSlide ? currentSlide : 0;
    const total = slick.slideCount;
    const dots = this.querySelectorAll('.slick-dots li');
    dots.forEach((dot, index) => {
      const button = dot.querySelector('button');
      if (index === current) {
        button.innerHTML = `${current + 1}/${total}`;
        dot.classList.add('slick-counter-active');
      } else {
        button.innerHTML = '';
        dot.classList.remove('slick-counter-active');
      }
    });
  });

  $slider.slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2.6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function initResultsPopup() {
  const triggerBtn = document.querySelector('.pagination-arrow-flex');
  const overlay = document.querySelector('.results-popup-overlay');
  const popup = document.querySelector('.results-popup');
  const closeBtn = document.querySelector('.results-popup-close');
  const popupContent = document.querySelector('.results-popup-content');

  if (!triggerBtn || !overlay || !popup || !popupContent) return;

  let cachedHTML = null;
  let fetchPromise = null;

  function fetchPage() {
    if (fetchPromise) return fetchPromise;

    fetchPromise = fetch('/pages/clinical-study-v2')
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const content =
          doc.querySelector('main') ||
          doc.querySelector('.main-content') ||
          doc.querySelector('#MainContent') ||
          doc.body;

        cachedHTML = content.innerHTML;
        return cachedHTML;
      })
      .catch(err => {
        console.error('Page load failed:', err);
        fetchPromise = null;
      });

    return fetchPromise;
  }

  fetchPage();

  triggerBtn.addEventListener('click', () => {
    fireEvent("clinical_study_clicked_rp", caseId);
    if (typeof trackMoengageEvent === 'function') trackMoengageEvent('clinical_study_entry_point_clicked');
    openPopup();
  });

  closeBtn?.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

  function openPopup() {
    overlay.classList.add('active');
    popup.classList.add('active');
    popup.scrollTop = 0;

    popupContent.innerHTML = `<p style="padding:20px;text-align:center;">Loading...</p>`;

    fetchPage().then((html) => {
      if (!html) {
        popupContent.innerHTML = `<p style="padding:20px;text-align:center;">Failed to load content.</p>`;
        return;
      }
      renderPopup();
    });
  }

  function renderPopup() {
    popupContent.innerHTML = cachedHTML;
    initResultsSlider('.journey-slider');
    initResultsSlider('.data-slider');
  }

  function closePopup() {
    overlay.classList.remove('active');
    popup.classList.remove('active');
  }
}
